export const lukkeyModuleTranslations = {
  es: {
    "lukkey.highlights.eyebrow": "Puntos clave",
    "lukkey.highlights.title": "Descubre los puntos clave de Lukkey.",
    "lukkey.highlights.description":
      "Primero entiende rápidamente las 5 ventajas más importantes de LUKKEY y luego explora cada sección con más detalle.",
    "lukkey.highlights.cards.chip.title": "Chip seguro EAL6+",
    "lukkey.highlights.cards.chip.description":
      "Una raíz de confianza a nivel de hardware protege el material criptográfico crítico dentro de un elemento seguro certificado.",
    "lukkey.highlights.cards.chip.sectionLabel": "Seguridad del chip",
    "lukkey.highlights.cards.multiAccount.title":
      "3 frases semilla independientes",
    "lukkey.highlights.cards.multiAccount.description":
      "Separa holdings a largo plazo, fondos diarios y estrategias distintas dentro de un solo dispositivo.",
    "lukkey.highlights.cards.multiAccount.sectionLabel": "Multicuenta",
    "lukkey.highlights.cards.safeMode.title": "Modo seguro",
    "lukkey.highlights.cards.safeMode.description":
      "Una interfaz disfrazada y un flujo de cuentas ocultas reducen la exposición en viajes, uso público y situaciones de coerción.",
    "lukkey.highlights.cards.safeMode.sectionLabel": "Capa de seguridad",
    "lukkey.highlights.cards.backup.title": "Tarjeta de respaldo NFC",
    "lukkey.highlights.cards.backup.description":
      "Toca para respaldar o restaurar frases de recuperación con una tarjeta dedicada pensada para continuidad offline.",
    "lukkey.highlights.cards.backup.sectionLabel": "Respaldo",
    "lukkey.highlights.cards.trust.title":
      "Seguridad abierta y verificable",
    "lukkey.highlights.cards.trust.description":
      "En una cold wallet importan las revisiones independientes. Una arquitectura abierta hace que la confianza pueda auditarse en lugar de asumirse.",
    "lukkey.highlights.cards.trust.sectionLabel": "Confianza",
    "lukkey.highlights.carousel.previous": "Grupo anterior",
    "lukkey.highlights.carousel.next": "Siguiente grupo",
    "lukkey.design.featureTitle":
      "Pantalla táctil a color · Cuerpo con tamaño de tarjeta",
    "lukkey.design.featureDescription":
      "Comparado 1:1 con una tarjeta bancaria real, resalta su grosor portátil de solo 9,6 mm.",
    "lukkey.design.thickness": "Grosor 9,6 mm",
    "lukkey.design.closing":
      "Incluso tras transiciones macro y reflejos fluidos, la forma final vuelve a ser sobria y refinada.",
    "lukkey.design.controls.closePanel": "Cerrar panel",
    "lukkey.design.feature.colors": "Colores",
    "lukkey.design.feature.sizes": "Dimensiones",
    "lukkey.design.feature.display": "Pantalla",
    "lukkey.design.feature.connectivity": "Conectividad",
    "lukkey.design.feature.durability": "Autonomía",
    "lukkey.design.color.champagne": "Champán",
    "lukkey.design.color.black": "Negro",
    "lukkey.design.color.silver": "Plata",
    "lukkey.design.panel.colors.title": "Colores.",
    "lukkey.design.panel.colors.body":
      "Disponible en tres acabados distintivos y fáciles de reconocer.",
    "lukkey.design.panel.colors.selected":
      "Ahora estás viendo LUKKEY en {{color}}.",
    "lukkey.design.panel.sizes.body":
      "Dimensiones: 93.2 mm (largo) x 56.7 mm (ancho) x 9.6 mm (alto). Peso: 85 g. Formato tipo tarjeta con un grosor compacto para el uso diario.",
    "lukkey.design.panel.display.body":
      "Pantalla: pantalla táctil de 4,3 pulgadas con resolución 480 x 800 para confirmar y firmar con claridad.",
    "lukkey.design.panel.connectivity.body":
      "Conectividad: compatible con Bluetooth para una conexión inalámbrica segura y un flujo de transacciones fluido.",
    "lukkey.design.panel.durability.body":
      "Autonomía: hasta 3 horas de uso continuo.",
    "lukkey.system.account.accountA": "Cuenta A",
    "lukkey.system.account.hiddenWallet": "Billetera oculta",
    "lukkey.system.account.decoyVault": "Billetera señuelo",
    "lukkey.system.account.locked": "Bloqueada",
    "lukkey.system.layers.primary": "Principal",
    "lukkey.system.layers.vault": "Vault",
    "lukkey.system.layers.shadow": "Sombra",
    "lukkey.system.modalImageAlt": "Imagen del producto LUKKEY Wallet",
    "lukkey.system.openDetailsAria": "Abrir detalles de {{title}}",
    "lukkey.system.safeModeAccess.titleStrong": "Acceso al\nmodo seguro",
    "lukkey.system.safeModeAccess.titleSoft":
      "Una contraseña especial abre una página disfrazada y oculta otras cuentas.",
    "lukkey.system.safeModeAccess.modalTitle": "Acceso al modo seguro",
    "lukkey.system.safeModeAccess.modalDescription":
      "Una contraseña dedicada para modo seguro abre una interfaz disfrazada de notas. Solo se muestra la cuenta objetivo y el resto de las billeteras permanece oculto.",
    "lukkey.system.safeModeAccess.bullet1":
      "Tras desbloquear, entras en una interfaz señuelo en lugar de la pantalla principal completa",
    "lukkey.system.safeModeAccess.bullet2":
      "Las cuentas que no son la actual permanecen fuera de la vista en situaciones sensibles",
    "lukkey.system.safeModeAccess.bullet3":
      "Reduce el riesgo de exponer activos ocultos en comprobaciones cotidianas",
    "lukkey.system.safeModeAccess.imageAlt":
      "Ilustración del acceso al modo seguro",
    "lukkey.system.hiddenAccounts.titleStrong": "Cuentas\nocultas",
    "lukkey.system.hiddenAccounts.titleSoft":
      "El acceso señuelo mantiene las billeteras sensibles ocultas hasta introducir la contraseña correcta.",
    "lukkey.system.hiddenAccounts.modalTitle": "Cuentas ocultas",
    "lukkey.system.hiddenAccounts.modalDescription":
      "Las billeteras sensibles quedan ocultas mediante el acceso señuelo. Solo al introducir la contraseña correcta se revela el conjunto real de cuentas, reduciendo el riesgo de exposición accidental.",
    "lukkey.system.hiddenAccounts.bullet1":
      "Separa una cuenta señuelo visible de billeteras ocultas de alto valor",
    "lukkey.system.hiddenAccounts.bullet2":
      "Evita que las billeteras ocultas aparezcan durante el desbloqueo diario",
    "lukkey.system.hiddenAccounts.bullet3":
      "Añade una capa de privacidad útil para viajes, espacios públicos y escenarios de coerción",
  },
  fr: {
    "lukkey.highlights.eyebrow": "Points forts",
    "lukkey.highlights.title": "Découvrez les points forts de Lukkey.",
    "lukkey.highlights.description":
      "Commencez par comprendre rapidement les 5 atouts majeurs de LUKKEY, puis approfondissez chaque section.",
    "lukkey.highlights.cards.chip.title": "Puce sécurisée EAL6+",
    "lukkey.highlights.cards.chip.description":
      "Une racine de confiance matérielle protège les éléments cryptographiques critiques à l'intérieur d'un composant sécurisé certifié.",
    "lukkey.highlights.cards.chip.sectionLabel": "Sécurité de la puce",
    "lukkey.highlights.cards.multiAccount.title":
      "3 phrases de récupération indépendantes",
    "lukkey.highlights.cards.multiAccount.description":
      "Séparez vos avoirs de long terme, vos fonds du quotidien et différentes stratégies sur un seul appareil.",
    "lukkey.highlights.cards.multiAccount.sectionLabel": "Multicomptes",
    "lukkey.highlights.cards.safeMode.title": "Mode sécurisé",
    "lukkey.highlights.cards.safeMode.description":
      "Une interface déguisée et des comptes cachés réduisent l'exposition en voyage, en public et dans les scénarios de contrainte.",
    "lukkey.highlights.cards.safeMode.sectionLabel": "Couche de sécurité",
    "lukkey.highlights.cards.backup.title": "Carte de sauvegarde NFC",
    "lukkey.highlights.cards.backup.description":
      "Touchez pour sauvegarder ou restaurer vos phrases de récupération avec une carte dédiée conçue pour la continuité hors ligne.",
    "lukkey.highlights.cards.backup.sectionLabel": "Sauvegarde",
    "lukkey.highlights.cards.trust.title":
      "Sécurité ouverte et vérifiable",
    "lukkey.highlights.cards.trust.description":
      "Pour un cold wallet, l'examen indépendant est essentiel. Une architecture ouverte rend la confiance vérifiable au lieu d'être simplement supposée.",
    "lukkey.highlights.cards.trust.sectionLabel": "Confiance",
    "lukkey.highlights.carousel.previous": "Points forts précédents",
    "lukkey.highlights.carousel.next": "Points forts suivants",
    "lukkey.design.featureTitle":
      "Écran tactile couleur · Format carte",
    "lukkey.design.featureDescription":
      "Comparé à une vraie carte bancaire à l'échelle 1:1, son épaisseur portable de seulement 9,6 mm ressort immédiatement.",
    "lukkey.design.thickness": "Épaisseur 9,6 mm",
    "lukkey.design.closing":
      "Même après les transitions macro et les reflets fluides, la forme finale reste maîtrisée et raffinée.",
    "lukkey.design.controls.closePanel": "Fermer le panneau",
    "lukkey.design.feature.colors": "Couleurs",
    "lukkey.design.feature.sizes": "Dimensions",
    "lukkey.design.feature.display": "Écran",
    "lukkey.design.feature.connectivity": "Connectivité",
    "lukkey.design.feature.durability": "Autonomie",
    "lukkey.design.color.champagne": "Champagne",
    "lukkey.design.color.black": "Noir",
    "lukkey.design.color.silver": "Argent",
    "lukkey.design.panel.colors.title": "Couleurs.",
    "lukkey.design.panel.colors.body":
      "Disponible en trois finitions distinctives et faciles à reconnaître.",
    "lukkey.design.panel.colors.selected":
      "Vous regardez actuellement LUKKEY en {{color}}.",
    "lukkey.design.panel.sizes.body":
      "Dimensions : 93,2 mm (L) x 56,7 mm (l) x 9,6 mm (H). Poids : 85 g. Un encombrement de carte bancaire avec une épaisseur compacte pensée pour un usage quotidien.",
    "lukkey.design.panel.display.body":
      "Écran : écran tactile 4,3 pouces, résolution 480 x 800, pour confirmer et signer clairement.",
    "lukkey.design.panel.connectivity.body":
      "Connectivité : prise en charge du Bluetooth pour une connexion sans fil sécurisée et des transactions fluides.",
    "lukkey.design.panel.durability.body":
      "Autonomie : jusqu'à 3 heures d'utilisation continue.",
    "lukkey.system.account.accountA": "Compte A",
    "lukkey.system.account.hiddenWallet": "Wallet caché",
    "lukkey.system.account.decoyVault": "Wallet leurre",
    "lukkey.system.account.locked": "Verrouillé",
    "lukkey.system.layers.primary": "Principal",
    "lukkey.system.layers.vault": "Coffre",
    "lukkey.system.layers.shadow": "Ombre",
    "lukkey.system.modalImageAlt": "Image produit du wallet LUKKEY",
    "lukkey.system.openDetailsAria": "Ouvrir les détails de {{title}}",
    "lukkey.system.safeModeAccess.titleStrong": "Accès au\nmode sécurisé",
    "lukkey.system.safeModeAccess.titleSoft":
      "Un mot de passe spécial ouvre une page déguisée et masque les autres comptes.",
    "lukkey.system.safeModeAccess.modalTitle": "Accès au mode sécurisé",
    "lukkey.system.safeModeAccess.modalDescription":
      "Un mot de passe dédié au mode sécurisé ouvre une interface déguisée en application de notes. Seul le compte ciblé est visible, tandis que les autres wallets restent cachés.",
    "lukkey.system.safeModeAccess.bullet1":
      "Après déverrouillage, vous arrivez sur une interface leurre plutôt que sur l'écran d'accueil complet",
    "lukkey.system.safeModeAccess.bullet2":
      "Les comptes autres que le compte actif restent hors de vue dans les situations sensibles",
    "lukkey.system.safeModeAccess.bullet3":
      "Réduit le risque d'exposer des actifs cachés lors de vérifications du quotidien",
    "lukkey.system.safeModeAccess.imageAlt":
      "Illustration de l'accès au mode sécurisé",
    "lukkey.system.hiddenAccounts.titleStrong": "Comptes\ncachés",
    "lukkey.system.hiddenAccounts.titleSoft":
      "L'accès leurre garde les wallets sensibles cachés jusqu'à la saisie du bon mot de passe.",
    "lukkey.system.hiddenAccounts.modalTitle": "Comptes cachés",
    "lukkey.system.hiddenAccounts.modalDescription":
      "Les wallets sensibles sont masqués par le mécanisme d'accès leurre. Le véritable ensemble de comptes n'apparaît qu'après saisie du bon mot de passe, ce qui réduit le risque d'exposition accidentelle.",
    "lukkey.system.hiddenAccounts.bullet1":
      "Sépare un compte leurre visible de wallets cachés à forte valeur",
    "lukkey.system.hiddenAccounts.bullet2":
      "Empêche l'apparition des wallets cachés lors du déverrouillage quotidien",
    "lukkey.system.hiddenAccounts.bullet3":
      "Ajoute une couche de confidentialité utile en voyage, dans les lieux publics et sous contrainte",
  },
  de: {
    "lukkey.highlights.eyebrow": "Kern-Highlights",
    "lukkey.highlights.title": "Entdecke die wichtigsten Highlights von Lukkey.",
    "lukkey.highlights.description":
      "Verschaffe dir zuerst einen schnellen Überblick über die 5 wichtigsten Vorteile von LUKKEY und tauche dann in die Details ein.",
    "lukkey.highlights.cards.chip.title": "EAL6+ Sicherheitschip",
    "lukkey.highlights.cards.chip.description":
      "Eine Hardware-Root-of-Trust schützt kritisches Schlüsselmaterial in einem zertifizierten Secure Element.",
    "lukkey.highlights.cards.chip.sectionLabel": "Chip-Sicherheit",
    "lukkey.highlights.cards.multiAccount.title":
      "3 unabhängige Seed-Phrases",
    "lukkey.highlights.cards.multiAccount.description":
      "Trenne langfristige Bestände, tägliche Mittel und unterschiedliche Strategien auf einem einzigen Gerät.",
    "lukkey.highlights.cards.multiAccount.sectionLabel": "Multi-Account",
    "lukkey.highlights.cards.safeMode.title": "Sicherheitsmodus",
    "lukkey.highlights.cards.safeMode.description":
      "Eine getarnte Oberfläche und versteckte Konten reduzieren Sichtbarkeit auf Reisen, in der Öffentlichkeit und in Zwangssituationen.",
    "lukkey.highlights.cards.safeMode.sectionLabel": "Sicherheitsebene",
    "lukkey.highlights.cards.backup.title": "NFC-Backup-Karte",
    "lukkey.highlights.cards.backup.description":
      "Per Tippen Recovery-Phrases sichern oder wiederherstellen, mit einer speziellen Karte für Offline-Kontinuität.",
    "lukkey.highlights.cards.backup.sectionLabel": "Backup",
    "lukkey.highlights.cards.trust.title":
      "Offene und überprüfbare Sicherheit",
    "lukkey.highlights.cards.trust.description":
      "Bei einer Cold Wallet zählt unabhängige Prüfung. Eine offene Architektur macht Vertrauen überprüfbar statt nur behauptet.",
    "lukkey.highlights.cards.trust.sectionLabel": "Vertrauen",
    "lukkey.highlights.carousel.previous": "Vorherige Highlights",
    "lukkey.highlights.carousel.next": "Nächste Highlights",
    "lukkey.design.featureTitle":
      "Farb-Touchscreen · Kartenformat",
    "lukkey.design.featureDescription":
      "Im 1:1-Vergleich mit einer echten Bankkarte fällt die portable Dicke von nur 9,6 mm sofort auf.",
    "lukkey.design.thickness": "Dicke 9,6 mm",
    "lukkey.design.closing":
      "Selbst nach Makro-Übergängen und fließenden Lichtreflexen kehrt die Form zu einer ruhigen, präzisen Gesamtwirkung zurück.",
    "lukkey.design.controls.closePanel": "Panel schließen",
    "lukkey.design.feature.colors": "Farben",
    "lukkey.design.feature.sizes": "Abmessungen",
    "lukkey.design.feature.display": "Display",
    "lukkey.design.feature.connectivity": "Konnektivität",
    "lukkey.design.feature.durability": "Akkulaufzeit",
    "lukkey.design.color.champagne": "Champagner",
    "lukkey.design.color.black": "Schwarz",
    "lukkey.design.color.silver": "Silber",
    "lukkey.design.panel.colors.title": "Farben.",
    "lukkey.design.panel.colors.body":
      "Erhältlich in drei markanten, klar wiedererkennbaren Farbvarianten.",
    "lukkey.design.panel.colors.selected":
      "Aktuell siehst du LUKKEY in {{color}}.",
    "lukkey.design.panel.sizes.body":
      "Abmessungen: 93,2 mm (L) x 56,7 mm (B) x 9,6 mm (H). Gewicht: 85 g. Kreditkartenformat mit kompakter Dicke für den täglichen Gebrauch.",
    "lukkey.design.panel.display.body":
      "Display: 4,3-Zoll-Touchscreen mit 480 x 800 Auflösung für klare Bestätigung und Signatur.",
    "lukkey.design.panel.connectivity.body":
      "Konnektivität: Bluetooth-Unterstützung für sichere drahtlose Verbindungen und einen reibungslosen Transaktionsfluss.",
    "lukkey.design.panel.durability.body":
      "Akkulaufzeit: bis zu 3 Stunden durchgehende Nutzung.",
    "lukkey.system.account.accountA": "Konto A",
    "lukkey.system.account.hiddenWallet": "Versteckte Wallet",
    "lukkey.system.account.decoyVault": "Täuschungs-Wallet",
    "lukkey.system.account.locked": "Gesperrt",
    "lukkey.system.layers.primary": "Primär",
    "lukkey.system.layers.vault": "Tresor",
    "lukkey.system.layers.shadow": "Schatten",
    "lukkey.system.modalImageAlt": "Produktbild der LUKKEY Wallet",
    "lukkey.system.openDetailsAria": "Details zu {{title}} öffnen",
    "lukkey.system.safeModeAccess.titleStrong":
      "Zugang zum\nSicherheitsmodus",
    "lukkey.system.safeModeAccess.titleSoft":
      "Ein spezielles Passwort öffnet eine getarnte Seite und verbirgt andere Konten.",
    "lukkey.system.safeModeAccess.modalTitle":
      "Zugang zum Sicherheitsmodus",
    "lukkey.system.safeModeAccess.modalDescription":
      "Ein spezielles Passwort für den Sicherheitsmodus öffnet eine als Notiz-App getarnte Oberfläche. Nur das Zielkonto ist sichtbar, alle anderen Wallets bleiben verborgen.",
    "lukkey.system.safeModeAccess.bullet1":
      "Nach dem Entsperren landest du auf einer Täuschungsoberfläche statt auf der vollständigen Wallet-Startseite",
    "lukkey.system.safeModeAccess.bullet2":
      "Nicht aktive Konten bleiben in sensiblen Situationen konsequent außer Sicht",
    "lukkey.system.safeModeAccess.bullet3":
      "Verringert das Risiko, versteckte Assets bei Routinekontrollen offenzulegen",
    "lukkey.system.safeModeAccess.imageAlt":
      "Illustration des Zugangs zum Sicherheitsmodus",
    "lukkey.system.hiddenAccounts.titleStrong": "Versteckte\nKonten",
    "lukkey.system.hiddenAccounts.titleSoft":
      "Täuschungszugang hält sensible Wallets verborgen, bis das korrekte Passwort eingegeben wird.",
    "lukkey.system.hiddenAccounts.modalTitle": "Versteckte Konten",
    "lukkey.system.hiddenAccounts.modalDescription":
      "Sensible Wallets werden über den Täuschungszugang verborgen. Erst mit dem richtigen Passwort wird der echte Kontensatz angezeigt, wodurch versehentliche Offenlegung reduziert wird.",
    "lukkey.system.hiddenAccounts.bullet1":
      "Trennt ein sichtbares Täuschungskonto von versteckten Wallets mit hohem Wert",
    "lukkey.system.hiddenAccounts.bullet2":
      "Verhindert, dass versteckte Wallets im alltäglichen Entsperrfluss erscheinen",
    "lukkey.system.hiddenAccounts.bullet3":
      "Ergänzt eine praktische Privatsphäre-Ebene für Reisen, öffentliche Räume und Zwangssituationen",
  },
  it: {
    "lukkey.highlights.eyebrow": "Punti chiave",
    "lukkey.highlights.title": "Scopri i punti chiave di Lukkey.",
    "lukkey.highlights.description":
      "Prima capisci rapidamente i 5 vantaggi principali di LUKKEY, poi approfondisci ogni sezione.",
    "lukkey.highlights.cards.chip.title": "Chip sicuro EAL6+",
    "lukkey.highlights.cards.chip.description":
      "Una root of trust hardware protegge il materiale crittografico più sensibile all'interno di un secure element certificato.",
    "lukkey.highlights.cards.chip.sectionLabel": "Sicurezza del chip",
    "lukkey.highlights.cards.multiAccount.title":
      "3 seed phrase indipendenti",
    "lukkey.highlights.cards.multiAccount.description":
      "Separa fondi a lungo termine, fondi quotidiani e strategie diverse su un unico dispositivo.",
    "lukkey.highlights.cards.multiAccount.sectionLabel": "Multi-account",
    "lukkey.highlights.cards.safeMode.title": "Modalità sicura",
    "lukkey.highlights.cards.safeMode.description":
      "Un'interfaccia camuffata e un flusso di account nascosti riducono l'esposizione in viaggio, in pubblico e in situazioni di coercizione.",
    "lukkey.highlights.cards.safeMode.sectionLabel": "Livello di sicurezza",
    "lukkey.highlights.cards.backup.title": "Scheda di backup NFC",
    "lukkey.highlights.cards.backup.description":
      "Tocca per eseguire il backup o ripristinare le frasi di recupero con una scheda dedicata pensata per la continuità offline.",
    "lukkey.highlights.cards.backup.sectionLabel": "Backup",
    "lukkey.highlights.cards.trust.title":
      "Sicurezza aperta e verificabile",
    "lukkey.highlights.cards.trust.description":
      "In un cold wallet conta la revisione indipendente. Un'architettura aperta rende la fiducia verificabile invece di essere solo presunta.",
    "lukkey.highlights.cards.trust.sectionLabel": "Affidabilità",
    "lukkey.highlights.carousel.previous": "Gruppo precedente",
    "lukkey.highlights.carousel.next": "Gruppo successivo",
    "lukkey.design.featureTitle":
      "Display touch a colori · Formato carta",
    "lukkey.design.featureDescription":
      "Confrontato 1:1 con una vera carta bancaria, mette in evidenza lo spessore portatile di soli 9,6 mm.",
    "lukkey.design.thickness": "Spessore 9,6 mm",
    "lukkey.design.closing":
      "Anche dopo transizioni macro e riflessi fluidi, la forma finale torna a essere sobria e raffinata.",
    "lukkey.design.controls.closePanel": "Chiudi pannello",
    "lukkey.design.feature.colors": "Colori",
    "lukkey.design.feature.sizes": "Dimensioni",
    "lukkey.design.feature.display": "Display",
    "lukkey.design.feature.connectivity": "Connettività",
    "lukkey.design.feature.durability": "Autonomia",
    "lukkey.design.color.champagne": "Champagne",
    "lukkey.design.color.black": "Nero",
    "lukkey.design.color.silver": "Argento",
    "lukkey.design.panel.colors.title": "Colori.",
    "lukkey.design.panel.colors.body":
      "Disponibile in tre finiture distintive e immediatamente riconoscibili.",
    "lukkey.design.panel.colors.selected":
      "Stai visualizzando LUKKEY in {{color}}.",
    "lukkey.design.panel.sizes.body":
      "Dimensioni: 93,2 mm (L) x 56,7 mm (W) x 9,6 mm (H). Peso: 85 g. Ingombro da carta di credito con spessore compatto per l'uso quotidiano.",
    "lukkey.design.panel.display.body":
      "Display: touchscreen da 4,3 pollici con risoluzione 480 x 800 per confermare e firmare con chiarezza.",
    "lukkey.design.panel.connectivity.body":
      "Connettività: supporto Bluetooth per una connessione wireless sicura e un flusso di transazioni fluido.",
    "lukkey.design.panel.durability.body":
      "Autonomia: fino a 3 ore di utilizzo continuo.",
    "lukkey.system.account.accountA": "Account A",
    "lukkey.system.account.hiddenWallet": "Wallet nascosto",
    "lukkey.system.account.decoyVault": "Wallet esca",
    "lukkey.system.account.locked": "Bloccato",
    "lukkey.system.layers.primary": "Primario",
    "lukkey.system.layers.vault": "Vault",
    "lukkey.system.layers.shadow": "Ombra",
    "lukkey.system.modalImageAlt": "Immagine prodotto del wallet LUKKEY",
    "lukkey.system.openDetailsAria": "Apri i dettagli di {{title}}",
    "lukkey.system.safeModeAccess.titleStrong":
      "Accesso alla\nmodalità sicura",
    "lukkey.system.safeModeAccess.titleSoft":
      "Una password speciale apre una pagina camuffata e nasconde gli altri account.",
    "lukkey.system.safeModeAccess.modalTitle":
      "Accesso alla modalità sicura",
    "lukkey.system.safeModeAccess.modalDescription":
      "Una password dedicata alla modalità sicura apre un'interfaccia mascherata da app note. Solo l'account di destinazione resta visibile e tutti gli altri wallet rimangono nascosti.",
    "lukkey.system.safeModeAccess.bullet1":
      "Dopo lo sblocco entri in un'interfaccia esca invece che nella home completa del wallet",
    "lukkey.system.safeModeAccess.bullet2":
      "Gli account diversi da quello corrente restano fuori vista nelle situazioni sensibili",
    "lukkey.system.safeModeAccess.bullet3":
      "Riduce il rischio di esporre asset nascosti durante controlli di routine",
    "lukkey.system.safeModeAccess.imageAlt":
      "Illustrazione dell'accesso alla modalità sicura",
    "lukkey.system.hiddenAccounts.titleStrong": "Account\nnascosti",
    "lukkey.system.hiddenAccounts.titleSoft":
      "L'accesso esca mantiene nascosti i wallet sensibili finché non viene inserita la password corretta.",
    "lukkey.system.hiddenAccounts.modalTitle": "Account nascosti",
    "lukkey.system.hiddenAccounts.modalDescription":
      "I wallet sensibili vengono nascosti tramite il meccanismo di accesso esca. Solo inserendo la password corretta compare il vero set di account, riducendo il rischio di esposizione accidentale.",
    "lukkey.system.hiddenAccounts.bullet1":
      "Separa un account esca visibile da wallet nascosti di alto valore",
    "lukkey.system.hiddenAccounts.bullet2":
      "Impedisce ai wallet nascosti di apparire nel flusso di sblocco quotidiano",
    "lukkey.system.hiddenAccounts.bullet3":
      "Aggiunge un utile livello di privacy per viaggi, luoghi pubblici e scenari di coercizione",
  },
  pt: {
    "lukkey.highlights.eyebrow": "Destaques",
    "lukkey.highlights.title": "Conheça os principais destaques da Lukkey.",
    "lukkey.highlights.description":
      "Primeiro entenda rapidamente os 5 benefícios mais importantes da LUKKEY e depois aprofunde cada seção.",
    "lukkey.highlights.cards.chip.title": "Chip seguro EAL6+",
    "lukkey.highlights.cards.chip.description":
      "Uma raiz de confiança em hardware protege o material criptográfico crítico dentro de um elemento seguro certificado.",
    "lukkey.highlights.cards.chip.sectionLabel": "Segurança do chip",
    "lukkey.highlights.cards.multiAccount.title":
      "3 seed phrases independentes",
    "lukkey.highlights.cards.multiAccount.description":
      "Separe reservas de longo prazo, fundos do dia a dia e estratégias diferentes em um único dispositivo.",
    "lukkey.highlights.cards.multiAccount.sectionLabel": "Multicontas",
    "lukkey.highlights.cards.safeMode.title": "Modo seguro",
    "lukkey.highlights.cards.safeMode.description":
      "Uma interface disfarçada e contas ocultas reduzem a exposição em viagens, uso público e cenários de coerção.",
    "lukkey.highlights.cards.safeMode.sectionLabel": "Camada de segurança",
    "lukkey.highlights.cards.backup.title": "Cartão de backup NFC",
    "lukkey.highlights.cards.backup.description":
      "Toque para fazer backup ou restaurar frases de recuperação com um cartão dedicado pensado para continuidade offline.",
    "lukkey.highlights.cards.backup.sectionLabel": "Backup",
    "lukkey.highlights.cards.trust.title":
      "Segurança aberta e verificável",
    "lukkey.highlights.cards.trust.description":
      "Em uma cold wallet, revisão independente importa. Uma arquitetura aberta torna a confiança auditável em vez de presumida.",
    "lukkey.highlights.cards.trust.sectionLabel": "Confiança",
    "lukkey.highlights.carousel.previous": "Grupo anterior",
    "lukkey.highlights.carousel.next": "Próximo grupo",
    "lukkey.design.featureTitle":
      "Tela touchscreen colorida · Formato cartão",
    "lukkey.design.featureDescription":
      "Comparado em 1:1 com um cartão bancário real, o destaque é a espessura portátil de apenas 9,6 mm.",
    "lukkey.design.thickness": "Espessura 9,6 mm",
    "lukkey.design.closing":
      "Mesmo após transições macro e reflexos fluidos, a forma final continua contida e refinada.",
    "lukkey.design.controls.closePanel": "Fechar painel",
    "lukkey.design.feature.colors": "Cores",
    "lukkey.design.feature.sizes": "Dimensões",
    "lukkey.design.feature.display": "Tela",
    "lukkey.design.feature.connectivity": "Conectividade",
    "lukkey.design.feature.durability": "Bateria",
    "lukkey.design.color.champagne": "Champanhe",
    "lukkey.design.color.black": "Preto",
    "lukkey.design.color.silver": "Prata",
    "lukkey.design.panel.colors.title": "Cores.",
    "lukkey.design.panel.colors.body":
      "Disponível em três acabamentos marcantes e fáceis de reconhecer.",
    "lukkey.design.panel.colors.selected":
      "Você está vendo a LUKKEY na cor {{color}}.",
    "lukkey.design.panel.sizes.body":
      "Dimensões: 93,2 mm (C) x 56,7 mm (L) x 9,6 mm (A). Peso: 85 g. Pegada de cartão de crédito com espessura compacta para o uso diário.",
    "lukkey.design.panel.display.body":
      "Tela: touchscreen de 4,3 polegadas com resolução 480 x 800 para confirmar e assinar com clareza.",
    "lukkey.design.panel.connectivity.body":
      "Conectividade: suporte a Bluetooth para conexão sem fio segura e fluxo de transações mais fluido.",
    "lukkey.design.panel.durability.body":
      "Bateria: até 3 horas de uso contínuo.",
    "lukkey.system.account.accountA": "Conta A",
    "lukkey.system.account.hiddenWallet": "Carteira oculta",
    "lukkey.system.account.decoyVault": "Carteira isca",
    "lukkey.system.account.locked": "Bloqueada",
    "lukkey.system.layers.primary": "Principal",
    "lukkey.system.layers.vault": "Cofre",
    "lukkey.system.layers.shadow": "Sombra",
    "lukkey.system.modalImageAlt": "Imagem do produto LUKKEY Wallet",
    "lukkey.system.openDetailsAria": "Abrir detalhes de {{title}}",
    "lukkey.system.safeModeAccess.titleStrong":
      "Acesso ao\nmodo seguro",
    "lukkey.system.safeModeAccess.titleSoft":
      "Uma senha especial abre uma página disfarçada e oculta outras contas.",
    "lukkey.system.safeModeAccess.modalTitle": "Acesso ao modo seguro",
    "lukkey.system.safeModeAccess.modalDescription":
      "Uma senha dedicada ao modo seguro abre uma interface disfarçada de app de notas. Apenas a conta alvo fica visível, enquanto as demais carteiras permanecem ocultas.",
    "lukkey.system.safeModeAccess.bullet1":
      "Após desbloquear, você entra em uma interface isca em vez da tela inicial completa da carteira",
    "lukkey.system.safeModeAccess.bullet2":
      "Contas que não são a atual permanecem fora de vista em situações sensíveis",
    "lukkey.system.safeModeAccess.bullet3":
      "Reduz o risco de expor ativos ocultos em verificações rotineiras",
    "lukkey.system.safeModeAccess.imageAlt":
      "Ilustração do acesso ao modo seguro",
    "lukkey.system.hiddenAccounts.titleStrong": "Contas\nocultas",
    "lukkey.system.hiddenAccounts.titleSoft":
      "O acesso isca mantém carteiras sensíveis ocultas até que a senha correta seja inserida.",
    "lukkey.system.hiddenAccounts.modalTitle": "Contas ocultas",
    "lukkey.system.hiddenAccounts.modalDescription":
      "Carteiras sensíveis são ocultadas pelo mecanismo de acesso isca. Somente com a senha correta o conjunto real de contas é exibido, reduzindo o risco de exposição acidental.",
    "lukkey.system.hiddenAccounts.bullet1":
      "Separa uma conta isca visível de carteiras ocultas de alto valor",
    "lukkey.system.hiddenAccounts.bullet2":
      "Impede que carteiras ocultas apareçam no fluxo diário de desbloqueio",
    "lukkey.system.hiddenAccounts.bullet3":
      "Adiciona uma camada prática de privacidade para viagens, locais públicos e cenários de coerção",
  },
  "pt-BR": {
    "lukkey.highlights.eyebrow": "Destaques",
    "lukkey.highlights.title": "Conheça os principais destaques da Lukkey.",
    "lukkey.highlights.description":
      "Primeiro entenda rapidamente os 5 benefícios mais importantes da LUKKEY e depois aprofunde cada seção.",
    "lukkey.highlights.cards.chip.title": "Chip seguro EAL6+",
    "lukkey.highlights.cards.chip.description":
      "Uma raiz de confiança em hardware protege o material criptográfico crítico dentro de um elemento seguro certificado.",
    "lukkey.highlights.cards.chip.sectionLabel": "Segurança do chip",
    "lukkey.highlights.cards.multiAccount.title":
      "3 seed phrases independentes",
    "lukkey.highlights.cards.multiAccount.description":
      "Separe reservas de longo prazo, fundos do dia a dia e estratégias diferentes em um único dispositivo.",
    "lukkey.highlights.cards.multiAccount.sectionLabel": "Multicontas",
    "lukkey.highlights.cards.safeMode.title": "Modo seguro",
    "lukkey.highlights.cards.safeMode.description":
      "Uma interface disfarçada e contas ocultas reduzem a exposição em viagens, uso público e cenários de coerção.",
    "lukkey.highlights.cards.safeMode.sectionLabel": "Camada de segurança",
    "lukkey.highlights.cards.backup.title": "Cartão de backup NFC",
    "lukkey.highlights.cards.backup.description":
      "Toque para fazer backup ou restaurar frases de recuperação com um cartão dedicado pensado para continuidade offline.",
    "lukkey.highlights.cards.backup.sectionLabel": "Backup",
    "lukkey.highlights.cards.trust.title":
      "Segurança aberta e verificável",
    "lukkey.highlights.cards.trust.description":
      "Em uma cold wallet, revisão independente importa. Uma arquitetura aberta torna a confiança auditável em vez de presumida.",
    "lukkey.highlights.cards.trust.sectionLabel": "Confiança",
    "lukkey.highlights.carousel.previous": "Grupo anterior",
    "lukkey.highlights.carousel.next": "Próximo grupo",
    "lukkey.design.featureTitle":
      "Tela touchscreen colorida · Formato cartão",
    "lukkey.design.featureDescription":
      "Comparado em 1:1 com um cartão bancário real, o destaque é a espessura portátil de apenas 9,6 mm.",
    "lukkey.design.thickness": "Espessura 9,6 mm",
    "lukkey.design.closing":
      "Mesmo após transições macro e reflexos fluidos, a forma final continua contida e refinada.",
    "lukkey.design.controls.closePanel": "Fechar painel",
    "lukkey.design.feature.colors": "Cores",
    "lukkey.design.feature.sizes": "Dimensões",
    "lukkey.design.feature.display": "Tela",
    "lukkey.design.feature.connectivity": "Conectividade",
    "lukkey.design.feature.durability": "Bateria",
    "lukkey.design.color.champagne": "Champanhe",
    "lukkey.design.color.black": "Preto",
    "lukkey.design.color.silver": "Prata",
    "lukkey.design.panel.colors.title": "Cores.",
    "lukkey.design.panel.colors.body":
      "Disponível em três acabamentos marcantes e fáceis de reconhecer.",
    "lukkey.design.panel.colors.selected":
      "Você está vendo a LUKKEY na cor {{color}}.",
    "lukkey.design.panel.sizes.body":
      "Dimensões: 93,2 mm (C) x 56,7 mm (L) x 9,6 mm (A). Peso: 85 g. Pegada de cartão de crédito com espessura compacta para o uso diário.",
    "lukkey.design.panel.display.body":
      "Tela: touchscreen de 4,3 polegadas com resolução 480 x 800 para confirmar e assinar com clareza.",
    "lukkey.design.panel.connectivity.body":
      "Conectividade: suporte a Bluetooth para conexão sem fio segura e fluxo de transações mais fluido.",
    "lukkey.design.panel.durability.body":
      "Bateria: até 3 horas de uso contínuo.",
    "lukkey.system.account.accountA": "Conta A",
    "lukkey.system.account.hiddenWallet": "Carteira oculta",
    "lukkey.system.account.decoyVault": "Carteira isca",
    "lukkey.system.account.locked": "Bloqueada",
    "lukkey.system.layers.primary": "Principal",
    "lukkey.system.layers.vault": "Cofre",
    "lukkey.system.layers.shadow": "Sombra",
    "lukkey.system.modalImageAlt": "Imagem do produto LUKKEY Wallet",
    "lukkey.system.openDetailsAria": "Abrir detalhes de {{title}}",
    "lukkey.system.safeModeAccess.titleStrong":
      "Acesso ao\nmodo seguro",
    "lukkey.system.safeModeAccess.titleSoft":
      "Uma senha especial abre uma página disfarçada e oculta outras contas.",
    "lukkey.system.safeModeAccess.modalTitle": "Acesso ao modo seguro",
    "lukkey.system.safeModeAccess.modalDescription":
      "Uma senha dedicada ao modo seguro abre uma interface disfarçada de app de notas. Apenas a conta alvo fica visível, enquanto as demais carteiras permanecem ocultas.",
    "lukkey.system.safeModeAccess.bullet1":
      "Após desbloquear, você entra em uma interface isca em vez da tela inicial completa da carteira",
    "lukkey.system.safeModeAccess.bullet2":
      "Contas que não são a atual permanecem fora de vista em situações sensíveis",
    "lukkey.system.safeModeAccess.bullet3":
      "Reduz o risco de expor ativos ocultos em verificações rotineiras",
    "lukkey.system.safeModeAccess.imageAlt":
      "Ilustração do acesso ao modo seguro",
    "lukkey.system.hiddenAccounts.titleStrong": "Contas\nocultas",
    "lukkey.system.hiddenAccounts.titleSoft":
      "O acesso isca mantém carteiras sensíveis ocultas até que a senha correta seja inserida.",
    "lukkey.system.hiddenAccounts.modalTitle": "Contas ocultas",
    "lukkey.system.hiddenAccounts.modalDescription":
      "Carteiras sensíveis são ocultadas pelo mecanismo de acesso isca. Somente com a senha correta o conjunto real de contas é exibido, reduzindo o risco de exposição acidental.",
    "lukkey.system.hiddenAccounts.bullet1":
      "Separa uma conta isca visível de carteiras ocultas de alto valor",
    "lukkey.system.hiddenAccounts.bullet2":
      "Impede que carteiras ocultas apareçam no fluxo diário de desbloqueio",
    "lukkey.system.hiddenAccounts.bullet3":
      "Adiciona uma camada prática de privacidade para viagens, locais públicos e cenários de coerção",
  },
  ja: {
    "lukkey.highlights.eyebrow": "主な特長",
    "lukkey.highlights.title": "Lukkey の主な特長をご覧ください。",
    "lukkey.highlights.description":
      "まずは LUKKEY の重要な 5 つの強みをすばやく把握し、その後に各セクションの詳細を確認してください。",
    "lukkey.highlights.cards.chip.title": "EAL6+ セキュアチップ",
    "lukkey.highlights.cards.chip.description":
      "ハードウェアレベルの信頼基盤が、認証済みセキュアエレメント内で重要な暗号鍵情報を保護します。",
    "lukkey.highlights.cards.chip.sectionLabel": "チップセキュリティ",
    "lukkey.highlights.cards.multiAccount.title": "3 つの独立したシードフレーズ",
    "lukkey.highlights.cards.multiAccount.description":
      "長期保有資産、日常資金、異なる運用戦略を 1 台のデバイスで分離して管理できます。",
    "lukkey.highlights.cards.multiAccount.sectionLabel": "マルチアカウント",
    "lukkey.highlights.cards.safeMode.title": "セーフモード",
    "lukkey.highlights.cards.safeMode.description":
      "偽装インターフェースと隠しアカウントの仕組みにより、旅行時・公共の場・強要リスクのある場面での露出を抑えます。",
    "lukkey.highlights.cards.safeMode.sectionLabel": "セーフティレイヤー",
    "lukkey.highlights.cards.backup.title": "NFC バックアップカード",
    "lukkey.highlights.cards.backup.description":
      "専用カードにタップするだけで、オフライン継続性のためのリカバリーフレーズのバックアップや復元が行えます。",
    "lukkey.highlights.cards.backup.sectionLabel": "バックアップ",
    "lukkey.highlights.cards.trust.title": "オープンで検証可能なセキュリティ",
    "lukkey.highlights.cards.trust.description":
      "コールドウォレットでは独立した検証が重要です。オープンなアーキテクチャにより、信頼は前提ではなく監査可能になります。",
    "lukkey.highlights.cards.trust.sectionLabel": "信頼",
    "lukkey.highlights.carousel.previous": "前の特長",
    "lukkey.highlights.carousel.next": "次の特長",
    "lukkey.design.featureTitle": "カラータッチスクリーン · カードサイズ設計",
    "lukkey.design.featureDescription":
      "実際の銀行カードと 1:1 で比較すると、わずか 9.6mm の携帯しやすい薄さが際立ちます。",
    "lukkey.design.thickness": "厚さ 9.6mm",
    "lukkey.design.closing":
      "マクロなトランジションや流れるようなハイライトの後でも、最終的なフォルムは抑制が効いた洗練された形に戻ります。",
    "lukkey.design.controls.closePanel": "パネルを閉じる",
    "lukkey.design.feature.colors": "カラー",
    "lukkey.design.feature.sizes": "サイズ",
    "lukkey.design.feature.display": "ディスプレイ",
    "lukkey.design.feature.connectivity": "接続性",
    "lukkey.design.feature.durability": "バッテリー",
    "lukkey.design.color.champagne": "シャンパン",
    "lukkey.design.color.black": "ブラック",
    "lukkey.design.color.silver": "シルバー",
    "lukkey.design.panel.colors.title": "カラー。",
    "lukkey.design.panel.colors.body":
      "個性があり見分けやすい 3 つの仕上げカラーを用意しています。",
    "lukkey.design.panel.colors.selected":
      "現在表示している LUKKEY のカラーは {{color}} です。",
    "lukkey.design.panel.sizes.body":
      "サイズ: 93.2 mm（長さ）x 56.7 mm（幅）x 9.6 mm（高さ）。重量: 85 g。クレジットカード級の設置面積と、日常携帯に適したコンパクトな薄さを備えています。",
    "lukkey.design.panel.display.body":
      "ディスプレイ: 4.3 インチのタッチスクリーン、解像度 480 x 800。確認や署名を明確に行えます。",
    "lukkey.design.panel.connectivity.body":
      "接続性: Bluetooth をサポートし、安全なワイヤレス接続とスムーズな取引フローを実現します。",
    "lukkey.design.panel.durability.body":
      "バッテリー: 最大 3 時間の連続使用が可能です。",
    "lukkey.system.account.accountA": "アカウント A",
    "lukkey.system.account.hiddenWallet": "隠しウォレット",
    "lukkey.system.account.decoyVault": "デコイウォレット",
    "lukkey.system.account.locked": "ロック済み",
    "lukkey.system.layers.primary": "メイン",
    "lukkey.system.layers.vault": "保管層",
    "lukkey.system.layers.shadow": "シャドウ",
    "lukkey.system.modalImageAlt": "LUKKEY ウォレット製品画像",
    "lukkey.system.openDetailsAria": "{{title}} の詳細を開く",
    "lukkey.system.safeModeAccess.titleStrong": "セーフモード\nアクセス",
    "lukkey.system.safeModeAccess.titleSoft":
      "専用パスワードを入力すると、偽装ページが開き、他のアカウントは隠されます。",
    "lukkey.system.safeModeAccess.modalTitle": "セーフモードアクセス",
    "lukkey.system.safeModeAccess.modalDescription":
      "専用のセーフモード用パスワードを入力すると、メモアプリに見える偽装インターフェースが開きます。対象アカウントだけが表示され、他のウォレット内容は隠れたままです。",
    "lukkey.system.safeModeAccess.bullet1":
      "解除後は完全なウォレットのホーム画面ではなく、デコイ用インターフェースに入ります",
    "lukkey.system.safeModeAccess.bullet2":
      "センシティブな状況でも、現在のアカウント以外は画面に表示されません",
    "lukkey.system.safeModeAccess.bullet3":
      "日常的な確認時に隠し資産が露出するリスクを減らします",
    "lukkey.system.safeModeAccess.imageAlt":
      "セーフモードアクセスのイラスト",
    "lukkey.system.hiddenAccounts.titleStrong": "隠し\nアカウント",
    "lukkey.system.hiddenAccounts.titleSoft":
      "デコイアクセスにより、正しいパスワードが入力されるまで重要なウォレットは隠されたままになります。",
    "lukkey.system.hiddenAccounts.modalTitle": "隠しアカウント",
    "lukkey.system.hiddenAccounts.modalDescription":
      "重要なウォレットはデコイアクセス機構によって隠されます。正しいパスワードが入力されたときだけ本来のアカウント群が表示され、意図しない露出リスクを減らします。",
    "lukkey.system.hiddenAccounts.bullet1":
      "見えているデコイアカウントと高価値の隠しウォレットを分離します",
    "lukkey.system.hiddenAccounts.bullet2":
      "日常の解除フローで隠しウォレットが表示されるのを防ぎます",
    "lukkey.system.hiddenAccounts.bullet3":
      "旅行時、公共の場、強要リスクのある場面で実用的なプライバシー層を追加します",
  },
  ko: {
    "lukkey.highlights.eyebrow": "핵심 포인트",
    "lukkey.highlights.title": "Lukkey의 핵심 포인트를 확인하세요.",
    "lukkey.highlights.description":
      "먼저 LUKKEY의 가장 중요한 5가지 장점을 빠르게 이해한 뒤, 각 섹션의 자세한 내용을 살펴보세요.",
    "lukkey.highlights.cards.chip.title": "EAL6+ 보안 칩",
    "lukkey.highlights.cards.chip.description":
      "하드웨어 수준의 신뢰 기반이 인증된 보안 요소 내부에서 핵심 암호 키 정보를 보호합니다.",
    "lukkey.highlights.cards.chip.sectionLabel": "칩 보안",
    "lukkey.highlights.cards.multiAccount.title": "독립형 시드 구문 3세트",
    "lukkey.highlights.cards.multiAccount.description":
      "장기 보유 자산, 일상 자금, 서로 다른 전략을 한 대의 기기에서 분리해 관리할 수 있습니다.",
    "lukkey.highlights.cards.multiAccount.sectionLabel": "멀티 계정",
    "lukkey.highlights.cards.safeMode.title": "세이프 모드",
    "lukkey.highlights.cards.safeMode.description":
      "위장 인터페이스와 숨김 계정 흐름이 여행, 공공장소, 강압 상황에서의 노출을 줄여줍니다.",
    "lukkey.highlights.cards.safeMode.sectionLabel": "보안 레이어",
    "lukkey.highlights.cards.backup.title": "NFC 백업 카드",
    "lukkey.highlights.cards.backup.description":
      "오프라인 연속성을 위해 전용 카드에 탭하여 복구 문구를 백업하거나 복원할 수 있습니다.",
    "lukkey.highlights.cards.backup.sectionLabel": "백업",
    "lukkey.highlights.cards.trust.title": "개방적이고 검증 가능한 보안",
    "lukkey.highlights.cards.trust.description":
      "콜드월렛에서는 독립 검증이 중요합니다. 오픈 아키텍처는 신뢰를 추정이 아닌 감사 가능한 상태로 만듭니다.",
    "lukkey.highlights.cards.trust.sectionLabel": "신뢰",
    "lukkey.highlights.carousel.previous": "이전 포인트",
    "lukkey.highlights.carousel.next": "다음 포인트",
    "lukkey.design.featureTitle": "컬러 터치스크린 · 카드형 바디",
    "lukkey.design.featureDescription":
      "실제 은행 카드와 1:1로 비교하면 단 9.6mm의 휴대성 높은 두께가 돋보입니다.",
    "lukkey.design.thickness": "두께 9.6mm",
    "lukkey.design.closing":
      "매크로 전환과 흐르는 하이라이트 이후에도 최종 형태는 절제되고 세련된 인상으로 돌아옵니다.",
    "lukkey.design.controls.closePanel": "패널 닫기",
    "lukkey.design.feature.colors": "색상",
    "lukkey.design.feature.sizes": "크기",
    "lukkey.design.feature.display": "디스플레이",
    "lukkey.design.feature.connectivity": "연결성",
    "lukkey.design.feature.durability": "배터리",
    "lukkey.design.color.champagne": "샴페인",
    "lukkey.design.color.black": "블랙",
    "lukkey.design.color.silver": "실버",
    "lukkey.design.panel.colors.title": "색상.",
    "lukkey.design.panel.colors.body":
      "개성이 뚜렷하고 쉽게 구분되는 세 가지 마감 컬러를 제공합니다.",
    "lukkey.design.panel.colors.selected":
      "현재 {{color}} 색상의 LUKKEY를 보고 있습니다.",
    "lukkey.design.panel.sizes.body":
      "크기: 93.2 mm(길이) x 56.7 mm(너비) x 9.6 mm(높이). 무게: 85 g. 신용카드급 면적과 일상 휴대에 적합한 컴팩트한 두께를 갖췄습니다.",
    "lukkey.design.panel.display.body":
      "디스플레이: 4.3인치 터치스크린, 480 x 800 해상도로 명확한 확인과 서명을 지원합니다.",
    "lukkey.design.panel.connectivity.body":
      "연결성: Bluetooth를 지원해 안전한 무선 연결과 매끄러운 거래 흐름을 제공합니다.",
    "lukkey.design.panel.durability.body":
      "배터리: 최대 3시간 연속 사용 가능합니다.",
    "lukkey.system.account.accountA": "계정 A",
    "lukkey.system.account.hiddenWallet": "숨김 지갑",
    "lukkey.system.account.decoyVault": "미끼 지갑",
    "lukkey.system.account.locked": "잠김",
    "lukkey.system.layers.primary": "기본",
    "lukkey.system.layers.vault": "금고",
    "lukkey.system.layers.shadow": "섀도우",
    "lukkey.system.modalImageAlt": "LUKKEY 지갑 제품 이미지",
    "lukkey.system.openDetailsAria": "{{title}} 상세 열기",
    "lukkey.system.safeModeAccess.titleStrong": "세이프 모드\n액세스",
    "lukkey.system.safeModeAccess.titleSoft":
      "전용 비밀번호를 입력하면 위장된 페이지가 열리고 다른 계정은 숨겨집니다.",
    "lukkey.system.safeModeAccess.modalTitle": "세이프 모드 액세스",
    "lukkey.system.safeModeAccess.modalDescription":
      "전용 세이프 모드 비밀번호를 입력하면 메모 앱처럼 보이는 위장 인터페이스가 열립니다. 대상 계정만 보이고 나머지 지갑은 계속 숨겨진 상태로 유지됩니다.",
    "lukkey.system.safeModeAccess.bullet1":
      "잠금 해제 후 전체 지갑 홈이 아니라 미끼용 인터페이스로 진입합니다",
    "lukkey.system.safeModeAccess.bullet2":
      "민감한 상황에서도 현재 계정이 아닌 다른 계정은 화면에 나타나지 않습니다",
    "lukkey.system.safeModeAccess.bullet3":
      "일상적인 확인 과정에서 숨겨진 자산이 노출될 위험을 줄입니다",
    "lukkey.system.safeModeAccess.imageAlt":
      "세이프 모드 액세스 일러스트",
    "lukkey.system.hiddenAccounts.titleStrong": "숨김\n계정",
    "lukkey.system.hiddenAccounts.titleSoft":
      "미끼 액세스는 올바른 비밀번호가 입력될 때까지 민감한 지갑을 숨겨 둡니다.",
    "lukkey.system.hiddenAccounts.modalTitle": "숨김 계정",
    "lukkey.system.hiddenAccounts.modalDescription":
      "민감한 지갑은 미끼 액세스 메커니즘으로 숨겨집니다. 올바른 비밀번호를 입력해야만 실제 계정 집합이 표시되어 우발적인 노출 위험을 줄입니다.",
    "lukkey.system.hiddenAccounts.bullet1":
      "보이는 미끼 계정과 고가치 숨김 지갑을 분리합니다",
    "lukkey.system.hiddenAccounts.bullet2":
      "일상 잠금 해제 흐름에서 숨김 지갑이 나타나는 것을 막습니다",
    "lukkey.system.hiddenAccounts.bullet3":
      "여행, 공공장소, 강압 상황에서 실용적인 프라이버시 레이어를 추가합니다",
  },
  ru: {
    "lukkey.highlights.eyebrow": "Ключевые преимущества",
    "lukkey.highlights.title": "Ознакомьтесь с ключевыми преимуществами Lukkey.",
    "lukkey.highlights.description":
      "Сначала быстро поймите 5 главных преимуществ LUKKEY, а затем изучите подробности в соответствующих разделах.",
    "lukkey.highlights.cards.chip.title": "Защищенный чип EAL6+",
    "lukkey.highlights.cards.chip.description":
      "Аппаратный корень доверия защищает критически важные криптографические данные внутри сертифицированного secure element.",
    "lukkey.highlights.cards.chip.sectionLabel": "Безопасность чипа",
    "lukkey.highlights.cards.multiAccount.title":
      "3 независимые seed-фразы",
    "lukkey.highlights.cards.multiAccount.description":
      "Разделяйте долгосрочные активы, ежедневные средства и разные стратегии на одном устройстве.",
    "lukkey.highlights.cards.multiAccount.sectionLabel": "Мультиаккаунт",
    "lukkey.highlights.cards.safeMode.title": "Безопасный режим",
    "lukkey.highlights.cards.safeMode.description":
      "Замаскированный интерфейс и скрытые аккаунты снижают раскрытие средств в поездках, в общественных местах и в ситуациях давления.",
    "lukkey.highlights.cards.safeMode.sectionLabel": "Уровень защиты",
    "lukkey.highlights.cards.backup.title": "NFC-карта резервного копирования",
    "lukkey.highlights.cards.backup.description":
      "Коснитесь карты, чтобы сохранить или восстановить фразы восстановления с помощью специальной карты для офлайн-непрерывности.",
    "lukkey.highlights.cards.backup.sectionLabel": "Резервная копия",
    "lukkey.highlights.cards.trust.title":
      "Открытая и проверяемая безопасность",
    "lukkey.highlights.cards.trust.description":
      "Для холодного кошелька важна независимая проверка. Открытая архитектура делает доверие проверяемым, а не предполагаемым.",
    "lukkey.highlights.cards.trust.sectionLabel": "Доверие",
    "lukkey.highlights.carousel.previous": "Предыдущие преимущества",
    "lukkey.highlights.carousel.next": "Следующие преимущества",
    "lukkey.design.featureTitle":
      "Цветной сенсорный экран · Корпус формата карты",
    "lukkey.design.featureDescription":
      "При сравнении 1:1 с реальной банковской картой особенно заметна портативная толщина всего 9,6 мм.",
    "lukkey.design.thickness": "Толщина 9,6 мм",
    "lukkey.design.closing":
      "Даже после макро-переходов и текучих бликов финальная форма остается сдержанной и утонченной.",
    "lukkey.design.controls.closePanel": "Закрыть панель",
    "lukkey.design.feature.colors": "Цвета",
    "lukkey.design.feature.sizes": "Размеры",
    "lukkey.design.feature.display": "Экран",
    "lukkey.design.feature.connectivity": "Подключение",
    "lukkey.design.feature.durability": "Автономность",
    "lukkey.design.color.champagne": "Шампань",
    "lukkey.design.color.black": "Черный",
    "lukkey.design.color.silver": "Серебристый",
    "lukkey.design.panel.colors.title": "Цвета.",
    "lukkey.design.panel.colors.body":
      "Доступны три выразительных и легко узнаваемых варианта отделки.",
    "lukkey.design.panel.colors.selected":
      "Сейчас вы видите LUKKEY в цвете {{color}}.",
    "lukkey.design.panel.sizes.body":
      "Размеры: 93,2 мм (длина) x 56,7 мм (ширина) x 9,6 мм (высота). Вес: 85 г. Формат банковской карты и компактная толщина для повседневного ношения.",
    "lukkey.design.panel.display.body":
      "Экран: 4,3-дюймовый сенсорный дисплей с разрешением 480 x 800 для четкого подтверждения и подписи.",
    "lukkey.design.panel.connectivity.body":
      "Подключение: поддержка Bluetooth для безопасного беспроводного соединения и плавного процесса транзакций.",
    "lukkey.design.panel.durability.body":
      "Автономность: до 3 часов непрерывного использования.",
    "lukkey.system.account.accountA": "Аккаунт A",
    "lukkey.system.account.hiddenWallet": "Скрытый кошелек",
    "lukkey.system.account.decoyVault": "Кошелек-приманка",
    "lukkey.system.account.locked": "Заблокировано",
    "lukkey.system.layers.primary": "Основной",
    "lukkey.system.layers.vault": "Хранилище",
    "lukkey.system.layers.shadow": "Тень",
    "lukkey.system.modalImageAlt": "Изображение продукта LUKKEY Wallet",
    "lukkey.system.openDetailsAria": "Открыть подробности для {{title}}",
    "lukkey.system.safeModeAccess.titleStrong":
      "Доступ к\nбезопасному режиму",
    "lukkey.system.safeModeAccess.titleSoft":
      "Специальный пароль открывает замаскированную страницу и скрывает другие аккаунты.",
    "lukkey.system.safeModeAccess.modalTitle":
      "Доступ к безопасному режиму",
    "lukkey.system.safeModeAccess.modalDescription":
      "Отдельный пароль для безопасного режима открывает интерфейс, замаскированный под заметки. Видимым остается только целевой аккаунт, а остальные кошельки остаются скрытыми.",
    "lukkey.system.safeModeAccess.bullet1":
      "После разблокировки вы попадаете в интерфейс-приманку, а не на полную домашнюю страницу кошелька",
    "lukkey.system.safeModeAccess.bullet2":
      "Аккаунты, кроме текущего, не появляются на экране в чувствительных сценариях",
    "lukkey.system.safeModeAccess.bullet3":
      "Снижает риск раскрытия скрытых активов при повседневных проверках",
    "lukkey.system.safeModeAccess.imageAlt":
      "Иллюстрация доступа к безопасному режиму",
    "lukkey.system.hiddenAccounts.titleStrong": "Скрытые\nаккаунты",
    "lukkey.system.hiddenAccounts.titleSoft":
      "Режим-приманка скрывает чувствительные кошельки, пока не будет введен правильный пароль.",
    "lukkey.system.hiddenAccounts.modalTitle": "Скрытые аккаунты",
    "lukkey.system.hiddenAccounts.modalDescription":
      "Чувствительные кошельки скрываются механизмом доступа-приманки. Только после ввода правильного пароля показывается настоящий набор аккаунтов, что снижает риск случайного раскрытия.",
    "lukkey.system.hiddenAccounts.bullet1":
      "Разделяет видимый аккаунт-приманку и скрытые кошельки с высокой ценностью",
    "lukkey.system.hiddenAccounts.bullet2":
      "Не дает скрытым кошелькам появляться в ежедневном сценарии разблокировки",
    "lukkey.system.hiddenAccounts.bullet3":
      "Добавляет практический уровень приватности для поездок, общественных мест и ситуаций принуждения",
  },
  uk: {
    "lukkey.highlights.eyebrow": "Ключові переваги",
    "lukkey.highlights.title": "Ознайомтеся з ключовими перевагами Lukkey.",
    "lukkey.highlights.description":
      "Спочатку швидко зрозумійте 5 головних переваг LUKKEY, а потім перегляньте деталі в кожному розділі.",
    "lukkey.highlights.cards.chip.title": "Захищений чип EAL6+",
    "lukkey.highlights.cards.chip.description":
      "Апаратний корінь довіри захищає критично важливі криптографічні дані всередині сертифікованого secure element.",
    "lukkey.highlights.cards.chip.sectionLabel": "Безпека чипа",
    "lukkey.highlights.cards.multiAccount.title":
      "3 незалежні seed-фрази",
    "lukkey.highlights.cards.multiAccount.description":
      "Розділяйте довгострокові активи, щоденні кошти та різні стратегії на одному пристрої.",
    "lukkey.highlights.cards.multiAccount.sectionLabel": "Мультиакаунт",
    "lukkey.highlights.cards.safeMode.title": "Безпечний режим",
    "lukkey.highlights.cards.safeMode.description":
      "Замаскований інтерфейс і приховані акаунти зменшують видимість активів у поїздках, публічних місцях і ситуаціях примусу.",
    "lukkey.highlights.cards.safeMode.sectionLabel": "Рівень захисту",
    "lukkey.highlights.cards.backup.title": "NFC-картка резервного копіювання",
    "lukkey.highlights.cards.backup.description":
      "Торкніться картки, щоб зберегти або відновити фрази відновлення за допомогою спеціальної картки для офлайн-безперервності.",
    "lukkey.highlights.cards.backup.sectionLabel": "Резервна копія",
    "lukkey.highlights.cards.trust.title":
      "Відкрита та перевірювана безпека",
    "lukkey.highlights.cards.trust.description":
      "Для cold wallet важлива незалежна перевірка. Відкрита архітектура робить довіру перевірюваною, а не просто припущеною.",
    "lukkey.highlights.cards.trust.sectionLabel": "Довіра",
    "lukkey.highlights.carousel.previous": "Попередні переваги",
    "lukkey.highlights.carousel.next": "Наступні переваги",
    "lukkey.design.featureTitle":
      "Кольоровий сенсорний екран · Формат картки",
    "lukkey.design.featureDescription":
      "У порівнянні 1:1 зі справжньою банківською карткою особливо помітна товщина лише 9,6 мм.",
    "lukkey.design.thickness": "Товщина 9,6 мм",
    "lukkey.design.closing":
      "Навіть після макро-переходів і плинних відблисків фінальна форма залишається стриманою та вишуканою.",
    "lukkey.design.controls.closePanel": "Закрити панель",
    "lukkey.design.feature.colors": "Кольори",
    "lukkey.design.feature.sizes": "Розміри",
    "lukkey.design.feature.display": "Екран",
    "lukkey.design.feature.connectivity": "Підключення",
    "lukkey.design.feature.durability": "Автономність",
    "lukkey.design.color.champagne": "Шампань",
    "lukkey.design.color.black": "Чорний",
    "lukkey.design.color.silver": "Сріблястий",
    "lukkey.design.panel.colors.title": "Кольори.",
    "lukkey.design.panel.colors.body":
      "Доступні три виразні й легко впізнавані варіанти оздоблення.",
    "lukkey.design.panel.colors.selected":
      "Зараз ви переглядаєте LUKKEY у кольорі {{color}}.",
    "lukkey.design.panel.sizes.body":
      "Розміри: 93,2 мм (довжина) x 56,7 мм (ширина) x 9,6 мм (висота). Вага: 85 г. Формат банківської картки й компактна товщина для щоденного носіння.",
    "lukkey.design.panel.display.body":
      "Екран: 4,3-дюймовий сенсорний дисплей з роздільною здатністю 480 x 800 для чіткого підтвердження та підпису.",
    "lukkey.design.panel.connectivity.body":
      "Підключення: підтримка Bluetooth для безпечного бездротового з'єднання та плавного процесу транзакцій.",
    "lukkey.design.panel.durability.body":
      "Автономність: до 3 годин безперервного використання.",
    "lukkey.system.account.accountA": "Акаунт A",
    "lukkey.system.account.hiddenWallet": "Прихований гаманець",
    "lukkey.system.account.decoyVault": "Гаманець-приманка",
    "lukkey.system.account.locked": "Заблоковано",
    "lukkey.system.layers.primary": "Основний",
    "lukkey.system.layers.vault": "Сховище",
    "lukkey.system.layers.shadow": "Тінь",
    "lukkey.system.modalImageAlt": "Зображення продукту LUKKEY Wallet",
    "lukkey.system.openDetailsAria": "Відкрити деталі для {{title}}",
    "lukkey.system.safeModeAccess.titleStrong":
      "Доступ до\nбезпечного режиму",
    "lukkey.system.safeModeAccess.titleSoft":
      "Спеціальний пароль відкриває замасковану сторінку та приховує інші акаунти.",
    "lukkey.system.safeModeAccess.modalTitle":
      "Доступ до безпечного режиму",
    "lukkey.system.safeModeAccess.modalDescription":
      "Окремий пароль для безпечного режиму відкриває інтерфейс, замаскований під нотатки. Видимим залишається лише цільовий акаунт, а решта гаманців залишаються прихованими.",
    "lukkey.system.safeModeAccess.bullet1":
      "Після розблокування ви потрапляєте в інтерфейс-приманку, а не на повну домашню сторінку гаманця",
    "lukkey.system.safeModeAccess.bullet2":
      "Акаунти, окрім поточного, не з'являються на екрані в чутливих ситуаціях",
    "lukkey.system.safeModeAccess.bullet3":
      "Зменшує ризик розкриття прихованих активів під час повсякденних перевірок",
    "lukkey.system.safeModeAccess.imageAlt":
      "Ілюстрація доступу до безпечного режиму",
    "lukkey.system.hiddenAccounts.titleStrong": "Приховані\nакаунти",
    "lukkey.system.hiddenAccounts.titleSoft":
      "Режим-приманка приховує чутливі гаманці, доки не буде введено правильний пароль.",
    "lukkey.system.hiddenAccounts.modalTitle": "Приховані акаунти",
    "lukkey.system.hiddenAccounts.modalDescription":
      "Чутливі гаманці приховуються механізмом доступу-приманки. Лише після введення правильного пароля відображається справжній набір акаунтів, що зменшує ризик випадкового розкриття.",
    "lukkey.system.hiddenAccounts.bullet1":
      "Відокремлює видимий акаунт-приманку від прихованих гаманців з високою цінністю",
    "lukkey.system.hiddenAccounts.bullet2":
      "Не дозволяє прихованим гаманцям з'являтися в щоденному сценарії розблокування",
    "lukkey.system.hiddenAccounts.bullet3":
      "Додає практичний рівень приватності для подорожей, публічних місць і ситуацій примусу",
  },
  id: {
    "lukkey.highlights.eyebrow": "Sorotan utama",
    "lukkey.highlights.title": "Lihat sorotan utama Lukkey.",
    "lukkey.highlights.description":
      "Pahami dulu 5 keunggulan terpenting LUKKEY secara cepat, lalu lanjutkan ke detail tiap bagiannya.",
    "lukkey.highlights.cards.chip.title": "Chip aman EAL6+",
    "lukkey.highlights.cards.chip.description":
      "Root of trust tingkat hardware melindungi material kriptografi penting di dalam secure element bersertifikasi.",
    "lukkey.highlights.cards.chip.sectionLabel": "Keamanan chip",
    "lukkey.highlights.cards.multiAccount.title":
      "3 seed phrase independen",
    "lukkey.highlights.cards.multiAccount.description":
      "Pisahkan aset jangka panjang, dana harian, dan strategi berbeda dalam satu perangkat.",
    "lukkey.highlights.cards.multiAccount.sectionLabel": "Multiakun",
    "lukkey.highlights.cards.safeMode.title": "Safe Mode",
    "lukkey.highlights.cards.safeMode.description":
      "Antarmuka tersamar dan alur akun tersembunyi mengurangi eksposur saat bepergian, di tempat umum, dan dalam situasi pemaksaan.",
    "lukkey.highlights.cards.safeMode.sectionLabel": "Lapisan keamanan",
    "lukkey.highlights.cards.backup.title": "Kartu backup NFC",
    "lukkey.highlights.cards.backup.description":
      "Ketuk untuk mencadangkan atau memulihkan recovery phrase dengan kartu khusus yang dirancang untuk kontinuitas offline.",
    "lukkey.highlights.cards.backup.sectionLabel": "Backup",
    "lukkey.highlights.cards.trust.title":
      "Keamanan terbuka dan dapat diverifikasi",
    "lukkey.highlights.cards.trust.description":
      "Untuk cold wallet, peninjauan independen itu penting. Arsitektur terbuka membuat kepercayaan bisa diaudit, bukan sekadar diasumsikan.",
    "lukkey.highlights.cards.trust.sectionLabel": "Kepercayaan",
    "lukkey.highlights.carousel.previous": "Sorotan sebelumnya",
    "lukkey.highlights.carousel.next": "Sorotan berikutnya",
    "lukkey.design.featureTitle":
      "Layar sentuh berwarna · Bodinya seukuran kartu",
    "lukkey.design.featureDescription":
      "Saat dibandingkan 1:1 dengan kartu bank asli, ketebalan portabelnya yang hanya 9,6 mm langsung menonjol.",
    "lukkey.design.thickness": "Ketebalan 9,6 mm",
    "lukkey.design.closing":
      "Bahkan setelah transisi makro dan highlight yang mengalir, bentuk akhirnya tetap terasa rapi dan elegan.",
    "lukkey.design.controls.closePanel": "Tutup panel",
    "lukkey.design.feature.colors": "Warna",
    "lukkey.design.feature.sizes": "Ukuran",
    "lukkey.design.feature.display": "Layar",
    "lukkey.design.feature.connectivity": "Konektivitas",
    "lukkey.design.feature.durability": "Baterai",
    "lukkey.design.color.champagne": "Champagne",
    "lukkey.design.color.black": "Hitam",
    "lukkey.design.color.silver": "Perak",
    "lukkey.design.panel.colors.title": "Warna.",
    "lukkey.design.panel.colors.body":
      "Tersedia dalam tiga pilihan finishing yang khas dan mudah dikenali.",
    "lukkey.design.panel.colors.selected":
      "Sekarang Anda sedang melihat LUKKEY berwarna {{color}}.",
    "lukkey.design.panel.sizes.body":
      "Dimensi: 93,2 mm (P) x 56,7 mm (L) x 9,6 mm (T). Berat: 85 g. Jejak seukuran kartu kredit dengan ketebalan ringkas untuk dibawa setiap hari.",
    "lukkey.design.panel.display.body":
      "Layar: layar sentuh 4,3 inci dengan resolusi 480 x 800 untuk konfirmasi dan penandatanganan yang jelas.",
    "lukkey.design.panel.connectivity.body":
      "Konektivitas: mendukung Bluetooth untuk koneksi nirkabel yang aman dan alur transaksi yang mulus.",
    "lukkey.design.panel.durability.body":
      "Baterai: hingga 3 jam penggunaan terus-menerus.",
    "lukkey.system.account.accountA": "Akun A",
    "lukkey.system.account.hiddenWallet": "Wallet tersembunyi",
    "lukkey.system.account.decoyVault": "Wallet umpan",
    "lukkey.system.account.locked": "Terkunci",
    "lukkey.system.layers.primary": "Utama",
    "lukkey.system.layers.vault": "Vault",
    "lukkey.system.layers.shadow": "Bayangan",
    "lukkey.system.modalImageAlt": "Gambar produk LUKKEY Wallet",
    "lukkey.system.openDetailsAria": "Buka detail untuk {{title}}",
    "lukkey.system.safeModeAccess.titleStrong": "Akses\nSafe Mode",
    "lukkey.system.safeModeAccess.titleSoft":
      "Kata sandi khusus membuka halaman tersamar dan menyembunyikan akun lain.",
    "lukkey.system.safeModeAccess.modalTitle": "Akses Safe Mode",
    "lukkey.system.safeModeAccess.modalDescription":
      "Kata sandi khusus untuk Safe Mode membuka antarmuka yang menyamar seperti aplikasi catatan. Hanya akun target yang terlihat, sementara wallet lainnya tetap tersembunyi.",
    "lukkey.system.safeModeAccess.bullet1":
      "Setelah terbuka, Anda masuk ke antarmuka umpan, bukan beranda wallet penuh",
    "lukkey.system.safeModeAccess.bullet2":
      "Akun selain akun aktif tetap tidak terlihat dalam situasi sensitif",
    "lukkey.system.safeModeAccess.bullet3":
      "Mengurangi risiko tereksposnya aset tersembunyi saat pemeriksaan rutin",
    "lukkey.system.safeModeAccess.imageAlt":
      "Ilustrasi akses Safe Mode",
    "lukkey.system.hiddenAccounts.titleStrong": "Akun\ntersembunyi",
    "lukkey.system.hiddenAccounts.titleSoft":
      "Akses umpan menjaga wallet sensitif tetap tersembunyi sampai kata sandi yang benar dimasukkan.",
    "lukkey.system.hiddenAccounts.modalTitle": "Akun tersembunyi",
    "lukkey.system.hiddenAccounts.modalDescription":
      "Wallet sensitif disembunyikan oleh mekanisme akses umpan. Hanya setelah kata sandi yang benar dimasukkan, kumpulan akun yang sebenarnya akan tampil, sehingga risiko eksposur tak sengaja berkurang.",
    "lukkey.system.hiddenAccounts.bullet1":
      "Memisahkan akun umpan yang terlihat dari wallet tersembunyi bernilai tinggi",
    "lukkey.system.hiddenAccounts.bullet2":
      "Mencegah wallet tersembunyi muncul dalam alur buka kunci harian",
    "lukkey.system.hiddenAccounts.bullet3":
      "Menambahkan lapisan privasi praktis untuk perjalanan, ruang publik, dan situasi pemaksaan",
  },
  vi: {
    "lukkey.highlights.eyebrow": "Điểm nổi bật",
    "lukkey.highlights.title": "Khám phá các điểm nổi bật của Lukkey.",
    "lukkey.highlights.description":
      "Trước tiên hãy nắm nhanh 5 lợi thế quan trọng nhất của LUKKEY, sau đó đi sâu vào từng phần chi tiết.",
    "lukkey.highlights.cards.chip.title": "Chip bảo mật EAL6+",
    "lukkey.highlights.cards.chip.description":
      "Một gốc tin cậy ở cấp phần cứng bảo vệ dữ liệu mật mã quan trọng bên trong secure element được chứng nhận.",
    "lukkey.highlights.cards.chip.sectionLabel": "Bảo mật chip",
    "lukkey.highlights.cards.multiAccount.title":
      "3 seed phrase độc lập",
    "lukkey.highlights.cards.multiAccount.description":
      "Tách biệt tài sản dài hạn, quỹ hằng ngày và các chiến lược khác nhau trên cùng một thiết bị.",
    "lukkey.highlights.cards.multiAccount.sectionLabel": "Đa tài khoản",
    "lukkey.highlights.cards.safeMode.title": "Safe Mode",
    "lukkey.highlights.cards.safeMode.description":
      "Giao diện ngụy trang và luồng tài khoản ẩn giúp giảm lộ tài sản khi di chuyển, ở nơi công cộng và trong tình huống bị ép buộc.",
    "lukkey.highlights.cards.safeMode.sectionLabel": "Lớp an toàn",
    "lukkey.highlights.cards.backup.title": "Thẻ sao lưu NFC",
    "lukkey.highlights.cards.backup.description":
      "Chạm để sao lưu hoặc khôi phục cụm từ khôi phục bằng thẻ chuyên dụng được thiết kế cho tính liên tục ngoại tuyến.",
    "lukkey.highlights.cards.backup.sectionLabel": "Sao lưu",
    "lukkey.highlights.cards.trust.title": "Bảo mật mở và có thể kiểm chứng",
    "lukkey.highlights.cards.trust.description":
      "Với cold wallet, đánh giá độc lập rất quan trọng. Kiến trúc mở biến niềm tin thành thứ có thể kiểm tra thay vì chỉ giả định.",
    "lukkey.highlights.cards.trust.sectionLabel": "Tin cậy",
    "lukkey.highlights.carousel.previous": "Nhóm trước",
    "lukkey.highlights.carousel.next": "Nhóm tiếp theo",
    "lukkey.design.featureTitle":
      "Màn hình cảm ứng màu · Thân máy cỡ thẻ",
    "lukkey.design.featureDescription":
      "Khi so sánh 1:1 với thẻ ngân hàng thật, độ dày di động chỉ 9,6 mm trở nên nổi bật ngay lập tức.",
    "lukkey.design.thickness": "Độ dày 9,6 mm",
    "lukkey.design.closing":
      "Ngay cả sau các chuyển cảnh macro và ánh phản chiếu chuyển động, hình dáng cuối cùng vẫn giữ được vẻ tinh gọn và tinh tế.",
    "lukkey.design.controls.closePanel": "Đóng bảng",
    "lukkey.design.feature.colors": "Màu sắc",
    "lukkey.design.feature.sizes": "Kích thước",
    "lukkey.design.feature.display": "Màn hình",
    "lukkey.design.feature.connectivity": "Kết nối",
    "lukkey.design.feature.durability": "Pin",
    "lukkey.design.color.champagne": "Champagne",
    "lukkey.design.color.black": "Đen",
    "lukkey.design.color.silver": "Bạc",
    "lukkey.design.panel.colors.title": "Màu sắc.",
    "lukkey.design.panel.colors.body":
      "Có ba tùy chọn hoàn thiện nổi bật và dễ nhận diện.",
    "lukkey.design.panel.colors.selected":
      "Bạn đang xem LUKKEY màu {{color}}.",
    "lukkey.design.panel.sizes.body":
      "Kích thước: 93,2 mm (D) x 56,7 mm (R) x 9,6 mm (C). Trọng lượng: 85 g. Diện tích tương đương thẻ tín dụng với độ dày gọn nhẹ để mang theo hằng ngày.",
    "lukkey.design.panel.display.body":
      "Màn hình: màn hình cảm ứng 4,3 inch, độ phân giải 480 x 800 để xác nhận và ký rõ ràng.",
    "lukkey.design.panel.connectivity.body":
      "Kết nối: hỗ trợ Bluetooth cho kết nối không dây an toàn và luồng giao dịch mượt mà.",
    "lukkey.design.panel.durability.body":
      "Pin: dùng liên tục tối đa 3 giờ.",
    "lukkey.system.account.accountA": "Tài khoản A",
    "lukkey.system.account.hiddenWallet": "Ví ẩn",
    "lukkey.system.account.decoyVault": "Ví mồi nhử",
    "lukkey.system.account.locked": "Đã khóa",
    "lukkey.system.layers.primary": "Chính",
    "lukkey.system.layers.vault": "Kho",
    "lukkey.system.layers.shadow": "Bóng",
    "lukkey.system.modalImageAlt": "Hình ảnh sản phẩm ví LUKKEY",
    "lukkey.system.openDetailsAria": "Mở chi tiết cho {{title}}",
    "lukkey.system.safeModeAccess.titleStrong": "Truy cập\nSafe Mode",
    "lukkey.system.safeModeAccess.titleSoft":
      "Mật khẩu chuyên dụng sẽ mở một trang ngụy trang và ẩn các tài khoản khác.",
    "lukkey.system.safeModeAccess.modalTitle": "Truy cập Safe Mode",
    "lukkey.system.safeModeAccess.modalDescription":
      "Mật khẩu dành riêng cho Safe Mode sẽ mở một giao diện được ngụy trang như ứng dụng ghi chú. Chỉ tài khoản mục tiêu được hiển thị, còn các ví khác vẫn bị ẩn.",
    "lukkey.system.safeModeAccess.bullet1":
      "Sau khi mở khóa, bạn vào giao diện mồi nhử thay vì trang chủ đầy đủ của ví",
    "lukkey.system.safeModeAccess.bullet2":
      "Các tài khoản ngoài tài khoản hiện tại luôn không xuất hiện trong tình huống nhạy cảm",
    "lukkey.system.safeModeAccess.bullet3":
      "Giảm nguy cơ lộ tài sản ẩn trong các lần kiểm tra thường ngày",
    "lukkey.system.safeModeAccess.imageAlt":
      "Minh họa truy cập Safe Mode",
    "lukkey.system.hiddenAccounts.titleStrong": "Tài khoản\nẩn",
    "lukkey.system.hiddenAccounts.titleSoft":
      "Cơ chế truy cập mồi nhử giữ các ví nhạy cảm ở trạng thái ẩn cho đến khi nhập đúng mật khẩu.",
    "lukkey.system.hiddenAccounts.modalTitle": "Tài khoản ẩn",
    "lukkey.system.hiddenAccounts.modalDescription":
      "Các ví nhạy cảm được ẩn bằng cơ chế truy cập mồi nhử. Chỉ khi nhập đúng mật khẩu, bộ tài khoản thật mới được hiển thị, giúp giảm nguy cơ lộ ngoài ý muốn.",
    "lukkey.system.hiddenAccounts.bullet1":
      "Tách tài khoản mồi nhử có thể nhìn thấy khỏi các ví ẩn giá trị cao",
    "lukkey.system.hiddenAccounts.bullet2":
      "Ngăn ví ẩn xuất hiện trong luồng mở khóa hằng ngày",
    "lukkey.system.hiddenAccounts.bullet3":
      "Thêm một lớp riêng tư thực dụng cho việc di chuyển, nơi công cộng và tình huống bị ép buộc",
  },
  th: {
    "lukkey.highlights.eyebrow": "จุดเด่นหลัก",
    "lukkey.highlights.title": "ดูจุดเด่นหลักของ Lukkey",
    "lukkey.highlights.description":
      "เริ่มจากทำความเข้าใจจุดแข็งสำคัญ 5 ข้อของ LUKKEY อย่างรวดเร็ว แล้วค่อยดูรายละเอียดในแต่ละส่วนต่อไป",
    "lukkey.highlights.cards.chip.title": "ชิปความปลอดภัย EAL6+",
    "lukkey.highlights.cards.chip.description":
      "รากฐานความเชื่อถือระดับฮาร์ดแวร์ปกป้องข้อมูลคริปโตสำคัญภายใน secure element ที่ผ่านการรับรอง",
    "lukkey.highlights.cards.chip.sectionLabel": "ความปลอดภัยของชิป",
    "lukkey.highlights.cards.multiAccount.title":
      "Seed phrase อิสระ 3 ชุด",
    "lukkey.highlights.cards.multiAccount.description":
      "แยกสินทรัพย์ระยะยาว เงินใช้ประจำวัน และกลยุทธ์ที่ต่างกันไว้ในอุปกรณ์เครื่องเดียว",
    "lukkey.highlights.cards.multiAccount.sectionLabel": "หลายบัญชี",
    "lukkey.highlights.cards.safeMode.title": "โหมดปลอดภัย",
    "lukkey.highlights.cards.safeMode.description":
      "อินเทอร์เฟซที่พรางตัวและระบบบัญชีที่ซ่อนไว้ช่วยลดการเปิดเผยสินทรัพย์ระหว่างเดินทาง ในที่สาธารณะ และในสถานการณ์ถูกบังคับ",
    "lukkey.highlights.cards.safeMode.sectionLabel": "ชั้นความปลอดภัย",
    "lukkey.highlights.cards.backup.title": "การ์ดสำรอง NFC",
    "lukkey.highlights.cards.backup.description":
      "แตะเพื่อสำรองหรือกู้คืน recovery phrase ด้วยการ์ดเฉพาะที่ออกแบบมาสำหรับความต่อเนื่องแบบออฟไลน์",
    "lukkey.highlights.cards.backup.sectionLabel": "การสำรองข้อมูล",
    "lukkey.highlights.cards.trust.title":
      "ความปลอดภัยแบบเปิดและตรวจสอบได้",
    "lukkey.highlights.cards.trust.description":
      "สำหรับ cold wallet การตรวจสอบโดยอิสระมีความสำคัญ สถาปัตยกรรมแบบเปิดทำให้ความเชื่อถือสามารถตรวจสอบได้ แทนที่จะเป็นเพียงการเชื่อเอาเอง",
    "lukkey.highlights.cards.trust.sectionLabel": "ความน่าเชื่อถือ",
    "lukkey.highlights.carousel.previous": "จุดเด่นก่อนหน้า",
    "lukkey.highlights.carousel.next": "จุดเด่นถัดไป",
    "lukkey.design.featureTitle":
      "หน้าจอสัมผัสสี · ตัวเครื่องขนาดบัตร",
    "lukkey.design.featureDescription":
      "เมื่อเทียบแบบ 1:1 กับบัตรธนาคารจริง จะเห็นความบางเพียง 9.6 มม. ที่พกพาง่ายอย่างชัดเจน",
    "lukkey.design.thickness": "ความหนา 9.6 มม.",
    "lukkey.design.closing":
      "แม้ผ่านทรานซิชันระยะใกล้และไฮไลต์ที่ลื่นไหล รูปทรงสุดท้ายก็ยังคงความเรียบและประณีต",
    "lukkey.design.controls.closePanel": "ปิดแผง",
    "lukkey.design.feature.colors": "สี",
    "lukkey.design.feature.sizes": "ขนาด",
    "lukkey.design.feature.display": "หน้าจอ",
    "lukkey.design.feature.connectivity": "การเชื่อมต่อ",
    "lukkey.design.feature.durability": "แบตเตอรี่",
    "lukkey.design.color.champagne": "แชมเปญ",
    "lukkey.design.color.black": "ดำ",
    "lukkey.design.color.silver": "เงิน",
    "lukkey.design.panel.colors.title": "สี.",
    "lukkey.design.panel.colors.body":
      "มีให้เลือก 3 โทนสีที่โดดเด่นและจดจำได้ง่าย",
    "lukkey.design.panel.colors.selected":
      "ตอนนี้คุณกำลังดู LUKKEY สี{{color}}",
    "lukkey.design.panel.sizes.body":
      "ขนาด: 93.2 มม. (ยาว) x 56.7 มม. (กว้าง) x 9.6 มม. (สูง) น้ำหนัก: 85 กรัม พื้นที่เท่าบัตรเครดิต พร้อมความบางกะทัดรัดสำหรับการพกพาในทุกวัน",
    "lukkey.design.panel.display.body":
      "หน้าจอ: หน้าจอสัมผัส 4.3 นิ้ว ความละเอียด 480 x 800 เพื่อการยืนยันและลงนามที่ชัดเจน",
    "lukkey.design.panel.connectivity.body":
      "การเชื่อมต่อ: รองรับ Bluetooth เพื่อการเชื่อมต่อไร้สายที่ปลอดภัยและขั้นตอนธุรกรรมที่ลื่นไหล",
    "lukkey.design.panel.durability.body":
      "แบตเตอรี่: ใช้งานต่อเนื่องได้นานสูงสุด 3 ชั่วโมง",
    "lukkey.system.account.accountA": "บัญชี A",
    "lukkey.system.account.hiddenWallet": "วอลเล็ตที่ซ่อนอยู่",
    "lukkey.system.account.decoyVault": "วอลเล็ตล่อ",
    "lukkey.system.account.locked": "ล็อกอยู่",
    "lukkey.system.layers.primary": "หลัก",
    "lukkey.system.layers.vault": "คลัง",
    "lukkey.system.layers.shadow": "เงา",
    "lukkey.system.modalImageAlt": "ภาพผลิตภัณฑ์ LUKKEY Wallet",
    "lukkey.system.openDetailsAria": "เปิดรายละเอียดของ {{title}}",
    "lukkey.system.safeModeAccess.titleStrong": "การเข้าถึง\nโหมดปลอดภัย",
    "lukkey.system.safeModeAccess.titleSoft":
      "รหัสผ่านพิเศษจะเปิดหน้าที่พรางไว้และซ่อนบัญชีอื่น",
    "lukkey.system.safeModeAccess.modalTitle": "การเข้าถึงโหมดปลอดภัย",
    "lukkey.system.safeModeAccess.modalDescription":
      "รหัสผ่านเฉพาะสำหรับโหมดปลอดภัยจะเปิดอินเทอร์เฟซที่ปลอมเป็นแอปโน้ต มีเพียงบัญชีเป้าหมายเท่านั้นที่แสดง ส่วนวอลเล็ตอื่นยังคงถูกซ่อนไว้",
    "lukkey.system.safeModeAccess.bullet1":
      "หลังปลดล็อก คุณจะเข้าสู่อินเทอร์เฟซล่อ ไม่ใช่หน้าโฮมเต็มของวอลเล็ต",
    "lukkey.system.safeModeAccess.bullet2":
      "บัญชีที่ไม่ใช่บัญชีปัจจุบันจะไม่ปรากฏบนหน้าจอในสถานการณ์อ่อนไหว",
    "lukkey.system.safeModeAccess.bullet3":
      "ลดความเสี่ยงที่สินทรัพย์ที่ซ่อนอยู่จะถูกเปิดเผยระหว่างการตรวจสอบทั่วไป",
    "lukkey.system.safeModeAccess.imageAlt":
      "ภาพประกอบการเข้าถึงโหมดปลอดภัย",
    "lukkey.system.hiddenAccounts.titleStrong": "บัญชี\nที่ซ่อนอยู่",
    "lukkey.system.hiddenAccounts.titleSoft":
      "การเข้าถึงแบบล่อจะซ่อนวอลเล็ตที่อ่อนไหวไว้จนกว่าจะใส่รหัสผ่านที่ถูกต้อง",
    "lukkey.system.hiddenAccounts.modalTitle": "บัญชีที่ซ่อนอยู่",
    "lukkey.system.hiddenAccounts.modalDescription":
      "วอลเล็ตที่อ่อนไหวจะถูกซ่อนด้วยกลไกการเข้าถึงแบบล่อ จะมีการแสดงชุดบัญชีจริงเมื่อใส่รหัสผ่านที่ถูกต้องเท่านั้น ช่วยลดความเสี่ยงจากการเปิดเผยโดยไม่ตั้งใจ",
    "lukkey.system.hiddenAccounts.bullet1":
      "แยกบัญชีล่อที่มองเห็นได้ออกจากวอลเล็ตที่ซ่อนอยู่และมีมูลค่าสูง",
    "lukkey.system.hiddenAccounts.bullet2":
      "ป้องกันไม่ให้วอลเล็ตที่ซ่อนอยู่ปรากฏในขั้นตอนปลดล็อกรายวัน",
    "lukkey.system.hiddenAccounts.bullet3":
      "เพิ่มชั้นความเป็นส่วนตัวที่ใช้งานได้จริงสำหรับการเดินทาง พื้นที่สาธารณะ และสถานการณ์ถูกบังคับ",
  },
  hi: {
    "lukkey.highlights.eyebrow": "मुख्य विशेषताएं",
    "lukkey.highlights.title": "Lukkey की मुख्य विशेषताएं देखें।",
    "lukkey.highlights.description":
      "पहले LUKKEY के 5 सबसे महत्वपूर्ण फायदों को जल्दी से समझें, फिर हर सेक्शन की पूरी जानकारी देखें।",
    "lukkey.highlights.cards.chip.title": "EAL6+ सुरक्षित चिप",
    "lukkey.highlights.cards.chip.description":
      "हार्डवेयर-स्तरीय ट्रस्ट रूट एक प्रमाणित secure element के भीतर महत्वपूर्ण क्रिप्टोग्राफिक डेटा की रक्षा करता है।",
    "lukkey.highlights.cards.chip.sectionLabel": "चिप सुरक्षा",
    "lukkey.highlights.cards.multiAccount.title":
      "3 स्वतंत्र सीड फ्रेज",
    "lukkey.highlights.cards.multiAccount.description":
      "लॉन्ग-टर्म होल्डिंग्स, रोज़मर्रा के फंड और अलग-अलग रणनीतियों को एक ही डिवाइस में अलग रखें।",
    "lukkey.highlights.cards.multiAccount.sectionLabel": "मल्टी-अकाउंट",
    "lukkey.highlights.cards.safeMode.title": "सेफ मोड",
    "lukkey.highlights.cards.safeMode.description":
      "छिपे हुए इंटरफेस और हिडन-अकाउंट फ्लो यात्रा, सार्वजनिक उपयोग और दबाव वाली परिस्थितियों में एक्सपोज़र कम करते हैं।",
    "lukkey.highlights.cards.safeMode.sectionLabel": "सुरक्षा परत",
    "lukkey.highlights.cards.backup.title": "NFC बैकअप कार्ड",
    "lukkey.highlights.cards.backup.description":
      "ऑफलाइन निरंतरता के लिए बने समर्पित कार्ड से रिकवरी फ्रेज़ का बैकअप या रिस्टोर करने के लिए टैप करें।",
    "lukkey.highlights.cards.backup.sectionLabel": "बैकअप",
    "lukkey.highlights.cards.trust.title":
      "ओपन और वेरिफ़ाएबल सुरक्षा",
    "lukkey.highlights.cards.trust.description":
      "कोल्ड वॉलेट में स्वतंत्र समीक्षा महत्वपूर्ण होती है। ओपन आर्किटेक्चर भरोसे को मान लेने के बजाय ऑडिट करने योग्य बनाता है।",
    "lukkey.highlights.cards.trust.sectionLabel": "विश्वास",
    "lukkey.highlights.carousel.previous": "पिछला समूह",
    "lukkey.highlights.carousel.next": "अगला समूह",
    "lukkey.design.featureTitle":
      "कलर टचस्क्रीन · कार्ड-साइज़ बॉडी",
    "lukkey.design.featureDescription":
      "असली बैंक कार्ड के साथ 1:1 तुलना में इसकी केवल 9.6 मिमी मोटाई तुरंत ध्यान खींचती है।",
    "lukkey.design.thickness": "मोटाई 9.6 मिमी",
    "lukkey.design.closing":
      "मैक्रो ट्रांज़िशन और फ्लुइड हाइलाइट्स के बाद भी अंतिम रूप संयमित और परिष्कृत बना रहता है।",
    "lukkey.design.controls.closePanel": "पैनल बंद करें",
    "lukkey.design.feature.colors": "रंग",
    "lukkey.design.feature.sizes": "आकार",
    "lukkey.design.feature.display": "डिस्प्ले",
    "lukkey.design.feature.connectivity": "कनेक्टिविटी",
    "lukkey.design.feature.durability": "बैटरी",
    "lukkey.design.color.champagne": "शैम्पेन",
    "lukkey.design.color.black": "काला",
    "lukkey.design.color.silver": "सिल्वर",
    "lukkey.design.panel.colors.title": "रंग.",
    "lukkey.design.panel.colors.body":
      "तीन अलग और तुरंत पहचाने जाने वाले फिनिश विकल्पों में उपलब्ध।",
    "lukkey.design.panel.colors.selected":
      "आप अभी {{color}} रंग वाला LUKKEY देख रहे हैं।",
    "lukkey.design.panel.sizes.body":
      "आकार: 93.2 मिमी (लंबाई) x 56.7 मिमी (चौड़ाई) x 9.6 मिमी (ऊंचाई)। वज़न: 85 ग्राम। क्रेडिट-कार्ड जैसा फ़ुटप्रिंट और रोज़मर्रा के उपयोग के लिए कॉम्पैक्ट मोटाई।",
    "lukkey.design.panel.display.body":
      "डिस्प्ले: 4.3-इंच टचस्क्रीन, 480 x 800 रेज़ोल्यूशन के साथ, ताकि पुष्टि और साइनिंग साफ़ दिखे।",
    "lukkey.design.panel.connectivity.body":
      "कनेक्टिविटी: सुरक्षित वायरलेस कनेक्शन और स्मूथ ट्रांज़ैक्शन फ़्लो के लिए Bluetooth सपोर्ट।",
    "lukkey.design.panel.durability.body":
      "बैटरी: लगातार उपयोग में अधिकतम 3 घंटे तक।",
    "lukkey.system.account.accountA": "अकाउंट A",
    "lukkey.system.account.hiddenWallet": "छिपा हुआ वॉलेट",
    "lukkey.system.account.decoyVault": "डिकॉय वॉलेट",
    "lukkey.system.account.locked": "लॉक्ड",
    "lukkey.system.layers.primary": "प्राथमिक",
    "lukkey.system.layers.vault": "वॉल्ट",
    "lukkey.system.layers.shadow": "शैडो",
    "lukkey.system.modalImageAlt": "LUKKEY वॉलेट प्रोडक्ट इमेज",
    "lukkey.system.openDetailsAria": "{{title}} की डिटेल खोलें",
    "lukkey.system.safeModeAccess.titleStrong": "सेफ मोड\nएक्सेस",
    "lukkey.system.safeModeAccess.titleSoft":
      "एक विशेष पासवर्ड एक छिपा हुआ पेज खोलता है और दूसरे अकाउंट छुपा देता है।",
    "lukkey.system.safeModeAccess.modalTitle": "सेफ मोड एक्सेस",
    "lukkey.system.safeModeAccess.modalDescription":
      "सेफ मोड के लिए अलग पासवर्ड नोट्स ऐप जैसा दिखने वाला इंटरफ़ेस खोलता है। सिर्फ लक्ष्य अकाउंट दिखता है और बाकी वॉलेट छिपे रहते हैं।",
    "lukkey.system.safeModeAccess.bullet1":
      "अनलॉक के बाद आप पूरे वॉलेट होमपेज की जगह डिकॉय इंटरफ़ेस में जाते हैं",
    "lukkey.system.safeModeAccess.bullet2":
      "संवेदनशील परिस्थितियों में मौजूदा अकाउंट के अलावा बाकी अकाउंट स्क्रीन पर नहीं दिखते",
    "lukkey.system.safeModeAccess.bullet3":
      "रूटीन जांच के दौरान छिपी हुई संपत्तियों के एक्सपोज़ होने का जोखिम कम करता है",
    "lukkey.system.safeModeAccess.imageAlt":
      "सेफ मोड एक्सेस का चित्रण",
    "lukkey.system.hiddenAccounts.titleStrong": "छिपे हुए\nअकाउंट",
    "lukkey.system.hiddenAccounts.titleSoft":
      "डिकॉय एक्सेस संवेदनशील वॉलेट्स को सही पासवर्ड डालने तक छिपाकर रखता है।",
    "lukkey.system.hiddenAccounts.modalTitle": "छिपे हुए अकाउंट",
    "lukkey.system.hiddenAccounts.modalDescription":
      "संवेदनशील वॉलेट डिकॉय एक्सेस मैकेनिज्म से छिपे रहते हैं। सही पासवर्ड डालने पर ही असली अकाउंट सेट दिखता है, जिससे अनचाही एक्सपोज़र का जोखिम घटता है।",
    "lukkey.system.hiddenAccounts.bullet1":
      "दिखने वाले डिकॉय अकाउंट और हाई-वैल्यू छिपे वॉलेट्स को अलग करता है",
    "lukkey.system.hiddenAccounts.bullet2":
      "रोज़मर्रा के अनलॉक फ्लो में छिपे वॉलेट्स को दिखने से रोकता है",
    "lukkey.system.hiddenAccounts.bullet3":
      "यात्रा, सार्वजनिक जगहों और दबाव वाली परिस्थितियों के लिए व्यावहारिक प्राइवेसी लेयर जोड़ता है",
  },
  ar: {
    "lukkey.highlights.eyebrow": "أبرز المزايا",
    "lukkey.highlights.title": "تعرّف على أبرز مزايا Lukkey.",
    "lukkey.highlights.description":
      "ابدأ بفهم أهم 5 مزايا في LUKKEY بسرعة، ثم تابع التفاصيل الكاملة في كل قسم.",
    "lukkey.highlights.cards.chip.title": "شريحة أمان EAL6+",
    "lukkey.highlights.cards.chip.description":
      "جذر ثقة على مستوى العتاد يحمي المواد التشفيرية الحساسة داخل عنصر أمني معتمد.",
    "lukkey.highlights.cards.chip.sectionLabel": "أمان الشريحة",
    "lukkey.highlights.cards.multiAccount.title":
      "3 عبارات استرداد مستقلة",
    "lukkey.highlights.cards.multiAccount.description":
      "افصل بين الأصول طويلة الأجل والأموال اليومية والاستراتيجيات المختلفة على جهاز واحد.",
    "lukkey.highlights.cards.multiAccount.sectionLabel": "حسابات متعددة",
    "lukkey.highlights.cards.safeMode.title": "الوضع الآمن",
    "lukkey.highlights.cards.safeMode.description":
      "واجهة مموهة وتدفق حسابات مخفية يقللان من انكشاف الأصول أثناء السفر والاستخدام العام وفي حالات الإكراه.",
    "lukkey.highlights.cards.safeMode.sectionLabel": "طبقة أمان",
    "lukkey.highlights.cards.backup.title": "بطاقة نسخ احتياطي NFC",
    "lukkey.highlights.cards.backup.description":
      "المس لإجراء نسخ احتياطي أو استعادة لعبارات الاسترداد باستخدام بطاقة مخصصة للاستمرارية دون اتصال.",
    "lukkey.highlights.cards.backup.sectionLabel": "النسخ الاحتياطي",
    "lukkey.highlights.cards.trust.title":
      "أمان مفتوح وقابل للتحقق",
    "lukkey.highlights.cards.trust.description":
      "في المحافظ الباردة، المراجعة المستقلة مهمة. البنية المفتوحة تجعل الثقة قابلة للتدقيق بدلاً من افتراضها.",
    "lukkey.highlights.cards.trust.sectionLabel": "الثقة",
    "lukkey.highlights.carousel.previous": "المجموعة السابقة",
    "lukkey.highlights.carousel.next": "المجموعة التالية",
    "lukkey.design.featureTitle":
      "شاشة لمس ملوّنة · هيكل بحجم البطاقة",
    "lukkey.design.featureDescription":
      "عند مقارنته 1:1 ببطاقة مصرفية حقيقية، يبرز سمكه المحمول الذي لا يتجاوز 9.6 مم.",
    "lukkey.design.thickness": "السماكة 9.6 مم",
    "lukkey.design.closing":
      "حتى بعد الانتقالات القريبة والانعكاسات المتحركة، تعود الهيئة النهائية إلى شكل متزن وراقي.",
    "lukkey.design.controls.closePanel": "إغلاق اللوحة",
    "lukkey.design.feature.colors": "الألوان",
    "lukkey.design.feature.sizes": "الأبعاد",
    "lukkey.design.feature.display": "الشاشة",
    "lukkey.design.feature.connectivity": "الاتصال",
    "lukkey.design.feature.durability": "البطارية",
    "lukkey.design.color.champagne": "شامبانيا",
    "lukkey.design.color.black": "أسود",
    "lukkey.design.color.silver": "فضي",
    "lukkey.design.panel.colors.title": "الألوان.",
    "lukkey.design.panel.colors.body":
      "متوفر بثلاثة تشطيبات مميزة وسهلة التعرّف.",
    "lukkey.design.panel.colors.selected":
      "أنت تشاهد الآن LUKKEY باللون {{color}}.",
    "lukkey.design.panel.sizes.body":
      "الأبعاد: 93.2 مم (الطول) x 56.7 مم (العرض) x 9.6 مم (الارتفاع). الوزن: 85 غراماً. مساحة بحجم بطاقة ائتمان مع سماكة مدمجة تناسب الحمل اليومي.",
    "lukkey.design.panel.display.body":
      "الشاشة: شاشة لمس 4.3 بوصة بدقة 480 x 800 لتأكيد وتوقيع واضحين.",
    "lukkey.design.panel.connectivity.body":
      "الاتصال: دعم Bluetooth لاتصال لاسلكي آمن وتدفق معاملات أكثر سلاسة.",
    "lukkey.design.panel.durability.body":
      "البطارية: حتى 3 ساعات من الاستخدام المتواصل.",
    "lukkey.system.account.accountA": "الحساب A",
    "lukkey.system.account.hiddenWallet": "محفظة مخفية",
    "lukkey.system.account.decoyVault": "محفظة تمويه",
    "lukkey.system.account.locked": "مقفلة",
    "lukkey.system.layers.primary": "أساسي",
    "lukkey.system.layers.vault": "الخزنة",
    "lukkey.system.layers.shadow": "الظل",
    "lukkey.system.modalImageAlt": "صورة منتج محفظة LUKKEY",
    "lukkey.system.openDetailsAria": "فتح تفاصيل {{title}}",
    "lukkey.system.safeModeAccess.titleStrong": "الوصول إلى\nالوضع الآمن",
    "lukkey.system.safeModeAccess.titleSoft":
      "تفتح كلمة مرور خاصة صفحة مموهة وتخفي الحسابات الأخرى.",
    "lukkey.system.safeModeAccess.modalTitle": "الوصول إلى الوضع الآمن",
    "lukkey.system.safeModeAccess.modalDescription":
      "تفتح كلمة مرور مخصصة للوضع الآمن واجهة متنكرة كتطبيق ملاحظات. لا يظهر سوى الحساب المستهدف، بينما تبقى المحافظ الأخرى مخفية.",
    "lukkey.system.safeModeAccess.bullet1":
      "بعد الفتح، تدخل إلى واجهة تمويه بدلاً من الصفحة الرئيسية الكاملة للمحفظة",
    "lukkey.system.safeModeAccess.bullet2":
      "تبقى الحسابات غير الحالية خارج الشاشة في المواقف الحساسة",
    "lukkey.system.safeModeAccess.bullet3":
      "يقلل من خطر كشف الأصول المخفية أثناء عمليات التحقق اليومية",
    "lukkey.system.safeModeAccess.imageAlt":
      "رسم توضيحي للوصول إلى الوضع الآمن",
    "lukkey.system.hiddenAccounts.titleStrong": "الحسابات\nالمخفية",
    "lukkey.system.hiddenAccounts.titleSoft":
      "يبقي وصول التمويه المحافظ الحساسة مخفية حتى إدخال كلمة المرور الصحيحة.",
    "lukkey.system.hiddenAccounts.modalTitle": "الحسابات المخفية",
    "lukkey.system.hiddenAccounts.modalDescription":
      "تُخفى المحافظ الحساسة عبر آلية وصول تمويهية. ولا تظهر المجموعة الحقيقية من الحسابات إلا بعد إدخال كلمة المرور الصحيحة، مما يقلل من خطر الانكشاف غير المقصود.",
    "lukkey.system.hiddenAccounts.bullet1":
      "يفصل بين حساب تمويه ظاهر ومحافظ مخفية عالية القيمة",
    "lukkey.system.hiddenAccounts.bullet2":
      "يمنع ظهور المحافظ المخفية أثناء مسار الفتح اليومي",
    "lukkey.system.hiddenAccounts.bullet3":
      "يضيف طبقة خصوصية عملية للسفر والأماكن العامة وحالات الإكراه",
  },
  tl: {
    "lukkey.highlights.eyebrow": "Mga pangunahing tampok",
    "lukkey.highlights.title": "Tingnan ang mga pangunahing tampok ng Lukkey.",
    "lukkey.highlights.description":
      "Unawain muna nang mabilis ang 5 pinakamahalagang benepisyo ng LUKKEY, saka tingnan ang buong detalye ng bawat seksyon.",
    "lukkey.highlights.cards.chip.title": "EAL6+ secure chip",
    "lukkey.highlights.cards.chip.description":
      "Pinoprotektahan ng hardware-level root of trust ang kritikal na cryptographic data sa loob ng sertipikadong secure element.",
    "lukkey.highlights.cards.chip.sectionLabel": "Seguridad ng chip",
    "lukkey.highlights.cards.multiAccount.title":
      "3 independent seed phrase",
    "lukkey.highlights.cards.multiAccount.description":
      "Paghiwalayin ang pangmatagalang holdings, araw-araw na pondo, at magkakaibang estratehiya sa iisang device.",
    "lukkey.highlights.cards.multiAccount.sectionLabel": "Multi-account",
    "lukkey.highlights.cards.safeMode.title": "Safe Mode",
    "lukkey.highlights.cards.safeMode.description":
      "Binabawasan ng disguised interface at hidden-account flow ang exposure sa biyahe, pampublikong paggamit, at coercion scenarios.",
    "lukkey.highlights.cards.safeMode.sectionLabel": "Safety layer",
    "lukkey.highlights.cards.backup.title": "NFC backup card",
    "lukkey.highlights.cards.backup.description":
      "I-tap para mag-backup o mag-restore ng recovery phrases gamit ang dedikadong card na ginawa para sa offline continuity.",
    "lukkey.highlights.cards.backup.sectionLabel": "Backup",
    "lukkey.highlights.cards.trust.title":
      "Open at napapatunayang seguridad",
    "lukkey.highlights.cards.trust.description":
      "Sa cold wallet, mahalaga ang independent review. Ginagawang naa-audit ng open architecture ang tiwala sa halip na basta ipagpalagay.",
    "lukkey.highlights.cards.trust.sectionLabel": "Tiwala",
    "lukkey.highlights.carousel.previous": "Nakaraang grupo",
    "lukkey.highlights.carousel.next": "Susunod na grupo",
    "lukkey.design.featureTitle":
      "Kulay na touchscreen · Katawang kasukat ng card",
    "lukkey.design.featureDescription":
      "Kapag inihambing nang 1:1 sa totoong bank card, kapansin-pansin agad ang portable na kapal na 9.6 mm lang.",
    "lukkey.design.thickness": "Kapal 9.6 mm",
    "lukkey.design.closing":
      "Kahit matapos ang macro transitions at dumadaloy na highlights, bumabalik pa rin ang pinal na anyo sa isang mahinahon at pinong porma.",
    "lukkey.design.controls.closePanel": "Isara ang panel",
    "lukkey.design.feature.colors": "Mga kulay",
    "lukkey.design.feature.sizes": "Sukat",
    "lukkey.design.feature.display": "Display",
    "lukkey.design.feature.connectivity": "Koneksyon",
    "lukkey.design.feature.durability": "Baterya",
    "lukkey.design.color.champagne": "Champagne",
    "lukkey.design.color.black": "Itim",
    "lukkey.design.color.silver": "Pilak",
    "lukkey.design.panel.colors.title": "Mga kulay.",
    "lukkey.design.panel.colors.body":
      "May tatlong kapansin-pansin at madaling makilalang finish options.",
    "lukkey.design.panel.colors.selected":
      "Kasalukuyan mong tinitingnan ang LUKKEY na {{color}}.",
    "lukkey.design.panel.sizes.body":
      "Sukat: 93.2 mm (haba) x 56.7 mm (lapad) x 9.6 mm (taas). Timbang: 85 g. Credit-card footprint na may compact na kapal para sa araw-araw na dala.",
    "lukkey.design.panel.display.body":
      "Display: 4.3-inch touchscreen na may 480 x 800 resolution para sa malinaw na pag-confirm at pag-sign.",
    "lukkey.design.panel.connectivity.body":
      "Koneksyon: may Bluetooth support para sa ligtas na wireless connection at mas maayos na transaction flow.",
    "lukkey.design.panel.durability.body":
      "Baterya: hanggang 3 oras ng tuloy-tuloy na paggamit.",
    "lukkey.system.account.accountA": "Account A",
    "lukkey.system.account.hiddenWallet": "Nakatagong wallet",
    "lukkey.system.account.decoyVault": "Decoy wallet",
    "lukkey.system.account.locked": "Naka-lock",
    "lukkey.system.layers.primary": "Pangunahing layer",
    "lukkey.system.layers.vault": "Vault",
    "lukkey.system.layers.shadow": "Anino",
    "lukkey.system.modalImageAlt": "Larawan ng produktong LUKKEY Wallet",
    "lukkey.system.openDetailsAria": "Buksan ang detalye ng {{title}}",
    "lukkey.system.safeModeAccess.titleStrong":
      "Access sa\nSafe Mode",
    "lukkey.system.safeModeAccess.titleSoft":
      "Binubuksan ng espesyal na password ang isang disguised page at itinatago ang ibang account.",
    "lukkey.system.safeModeAccess.modalTitle": "Access sa Safe Mode",
    "lukkey.system.safeModeAccess.modalDescription":
      "Ang nakalaang password para sa Safe Mode ay nagbubukas ng interface na mukhang notes app. Tanging ang target na account lang ang makikita at mananatiling nakatago ang ibang wallet.",
    "lukkey.system.safeModeAccess.bullet1":
      "Pagkatapos mag-unlock, mapupunta ka sa decoy interface imbes na sa buong wallet homepage",
    "lukkey.system.safeModeAccess.bullet2":
      "Nananatiling hindi nakikita ang mga account na hindi kasalukuyang aktibo sa sensitibong sitwasyon",
    "lukkey.system.safeModeAccess.bullet3":
      "Binabawasan ang panganib na ma-expose ang mga nakatagong asset sa pang-araw-araw na pagsusuri",
    "lukkey.system.safeModeAccess.imageAlt":
      "Ilustrasyon ng access sa Safe Mode",
    "lukkey.system.hiddenAccounts.titleStrong": "Nakatagong\naccount",
    "lukkey.system.hiddenAccounts.titleSoft":
      "Pinananatiling nakatago ng decoy access ang mga sensitibong wallet hanggang mailagay ang tamang password.",
    "lukkey.system.hiddenAccounts.modalTitle": "Nakatagong account",
    "lukkey.system.hiddenAccounts.modalDescription":
      "Itinatago ang mga sensitibong wallet sa pamamagitan ng decoy access mechanism. Lalabas lang ang tunay na set ng account kapag nailagay ang tamang password, kaya nababawasan ang aksidenteng exposure.",
    "lukkey.system.hiddenAccounts.bullet1":
      "Inihihiwalay ang nakikitang decoy account sa mga high-value na nakatagong wallet",
    "lukkey.system.hiddenAccounts.bullet2":
      "Pinipigilan ang paglitaw ng mga nakatagong wallet sa pang-araw-araw na unlock flow",
    "lukkey.system.hiddenAccounts.bullet3":
      "Nagdaragdag ng praktikal na privacy layer para sa biyahe, pampublikong lugar, at coercion scenarios",
  },
  bn: {
    "lukkey.highlights.eyebrow": "মূল বৈশিষ্ট্য",
    "lukkey.highlights.title": "Lukkey-এর মূল বৈশিষ্ট্যগুলো দেখুন।",
    "lukkey.highlights.description":
      "আগে LUKKEY-এর সবচেয়ে গুরুত্বপূর্ণ ৫টি সুবিধা দ্রুত বুঝে নিন, তারপর প্রতিটি সেকশনের বিস্তারিত দেখুন।",
    "lukkey.highlights.cards.chip.title": "EAL6+ সিকিউর চিপ",
    "lukkey.highlights.cards.chip.description":
      "হার্ডওয়্যার-স্তরের ট্রাস্ট রুট একটি সার্টিফায়েড secure element-এর ভেতরে গুরুত্বপূর্ণ ক্রিপ্টোগ্রাফিক ডেটা সুরক্ষিত রাখে।",
    "lukkey.highlights.cards.chip.sectionLabel": "চিপ সুরক্ষা",
    "lukkey.highlights.cards.multiAccount.title":
      "৩টি স্বতন্ত্র সিড ফ্রেজ",
    "lukkey.highlights.cards.multiAccount.description":
      "দীর্ঘমেয়াদি সম্পদ, দৈনন্দিন তহবিল এবং ভিন্ন কৌশল একই ডিভাইসে আলাদা করে রাখুন।",
    "lukkey.highlights.cards.multiAccount.sectionLabel": "মাল্টি-অ্যাকাউন্ট",
    "lukkey.highlights.cards.safeMode.title": "সেফ মোড",
    "lukkey.highlights.cards.safeMode.description":
      "ছদ্মবেশী ইন্টারফেস ও হিডেন-অ্যাকাউন্ট ফ্লো ভ্রমণ, পাবলিক-ইউজ এবং জবরদস্তিমূলক পরিস্থিতিতে এক্সপোজার কমায়।",
    "lukkey.highlights.cards.safeMode.sectionLabel": "সুরক্ষা স্তর",
    "lukkey.highlights.cards.backup.title": "NFC ব্যাকআপ কার্ড",
    "lukkey.highlights.cards.backup.description":
      "অফলাইন ধারাবাহিকতার জন্য তৈরি ডেডিকেটেড কার্ড দিয়ে রিকভারি ফ্রেজ ব্যাকআপ বা রিস্টোর করতে ট্যাপ করুন।",
    "lukkey.highlights.cards.backup.sectionLabel": "ব্যাকআপ",
    "lukkey.highlights.cards.trust.title":
      "ওপেন ও যাচাইযোগ্য নিরাপত্তা",
    "lukkey.highlights.cards.trust.description":
      "কোল্ড ওয়ালেটে স্বাধীন পর্যালোচনা গুরুত্বপূর্ণ। ওপেন আর্কিটেকচার বিশ্বাসকে অনুমান নয়, অডিটযোগ্য করে তোলে।",
    "lukkey.highlights.cards.trust.sectionLabel": "বিশ্বাস",
    "lukkey.highlights.carousel.previous": "আগের গ্রুপ",
    "lukkey.highlights.carousel.next": "পরের গ্রুপ",
    "lukkey.design.featureTitle":
      "রঙিন টাচস্ক্রিন · কার্ড-সাইজ বডি",
    "lukkey.design.featureDescription":
      "আসল ব্যাংক কার্ডের সাথে 1:1 তুলনায় মাত্র 9.6 মিমি পুরুত্বটি সঙ্গে সঙ্গে নজরে আসে।",
    "lukkey.design.thickness": "পুরুত্ব 9.6 মিমি",
    "lukkey.design.closing":
      "ম্যাক্রো ট্রানজিশন ও তরল হাইলাইটের পরও চূড়ান্ত গঠনটি সংযত ও পরিশীলিত থাকে।",
    "lukkey.design.controls.closePanel": "প্যানেল বন্ধ করুন",
    "lukkey.design.feature.colors": "রং",
    "lukkey.design.feature.sizes": "মাপ",
    "lukkey.design.feature.display": "ডিসপ্লে",
    "lukkey.design.feature.connectivity": "কানেক্টিভিটি",
    "lukkey.design.feature.durability": "ব্যাটারি",
    "lukkey.design.color.champagne": "শ্যাম্পেন",
    "lukkey.design.color.black": "কালো",
    "lukkey.design.color.silver": "রূপালি",
    "lukkey.design.panel.colors.title": "রং.",
    "lukkey.design.panel.colors.body":
      "তিনটি আলাদা এবং সহজে চেনা যায় এমন ফিনিশে উপলব্ধ।",
    "lukkey.design.panel.colors.selected":
      "আপনি এখন {{color}} রঙের LUKKEY দেখছেন।",
    "lukkey.design.panel.sizes.body":
      "মাপ: 93.2 মিমি (দৈর্ঘ্য) x 56.7 মিমি (প্রস্থ) x 9.6 মিমি (উচ্চতা)। ওজন: 85 গ্রাম। ক্রেডিট-কার্ড সাইজের ফুটপ্রিন্ট এবং দৈনন্দিন বহনের জন্য কমপ্যাক্ট পুরুত্ব।",
    "lukkey.design.panel.display.body":
      "ডিসপ্লে: 4.3-ইঞ্চি টাচস্ক্রিন, 480 x 800 রেজোলিউশনসহ, যাতে কনফার্মেশন ও সাইনিং স্পষ্ট হয়।",
    "lukkey.design.panel.connectivity.body":
      "কানেক্টিভিটি: নিরাপদ ওয়্যারলেস সংযোগ এবং মসৃণ ট্রানজ্যাকশন ফ্লোর জন্য Bluetooth সমর্থন।",
    "lukkey.design.panel.durability.body":
      "ব্যাটারি: টানা সর্বোচ্চ 3 ঘণ্টা ব্যবহার করা যায়।",
    "lukkey.system.account.accountA": "অ্যাকাউন্ট A",
    "lukkey.system.account.hiddenWallet": "লুকানো ওয়ালেট",
    "lukkey.system.account.decoyVault": "ডিকয় ওয়ালেট",
    "lukkey.system.account.locked": "লক করা",
    "lukkey.system.layers.primary": "প্রাইমারি",
    "lukkey.system.layers.vault": "ভল্ট",
    "lukkey.system.layers.shadow": "শ্যাডো",
    "lukkey.system.modalImageAlt": "LUKKEY ওয়ালেট পণ্যের ছবি",
    "lukkey.system.openDetailsAria": "{{title}}-এর বিস্তারিত খুলুন",
    "lukkey.system.safeModeAccess.titleStrong": "সেফ মোড\nঅ্যাক্সেস",
    "lukkey.system.safeModeAccess.titleSoft":
      "একটি বিশেষ পাসওয়ার্ড ছদ্মবেশী পেজ খুলে দেয় এবং অন্য অ্যাকাউন্টগুলো লুকিয়ে রাখে।",
    "lukkey.system.safeModeAccess.modalTitle": "সেফ মোড অ্যাক্সেস",
    "lukkey.system.safeModeAccess.modalDescription":
      "সেফ মোডের জন্য নির্দিষ্ট পাসওয়ার্ড একটি নোটস অ্যাপের মতো ছদ্মবেশী ইন্টারফেস খোলে। শুধু লক্ষ্য অ্যাকাউন্টটি দেখা যায়, বাকি ওয়ালেটগুলো লুকানো থাকে।",
    "lukkey.system.safeModeAccess.bullet1":
      "আনলক করার পর আপনি পূর্ণ ওয়ালেট হোমপেজে নয়, ডিকয় ইন্টারফেসে প্রবেশ করেন",
    "lukkey.system.safeModeAccess.bullet2":
      "সংবেদনশীল পরিস্থিতিতে বর্তমান অ্যাকাউন্ট ছাড়া অন্য অ্যাকাউন্ট স্ক্রিনে দেখায় না",
    "lukkey.system.safeModeAccess.bullet3":
      "রুটিন চেকের সময় লুকানো সম্পদ প্রকাশ পাওয়ার ঝুঁকি কমায়",
    "lukkey.system.safeModeAccess.imageAlt":
      "সেফ মোড অ্যাক্সেসের ইলাস্ট্রেশন",
    "lukkey.system.hiddenAccounts.titleStrong": "লুকানো\nঅ্যাকাউন্ট",
    "lukkey.system.hiddenAccounts.titleSoft":
      "ডিকয় অ্যাক্সেস সংবেদনশীল ওয়ালেটগুলোকে সঠিক পাসওয়ার্ড না দেওয়া পর্যন্ত লুকিয়ে রাখে।",
    "lukkey.system.hiddenAccounts.modalTitle": "লুকানো অ্যাকাউন্ট",
    "lukkey.system.hiddenAccounts.modalDescription":
      "সংবেদনশীল ওয়ালেটগুলো ডিকয় অ্যাক্সেস মেকানিজমের মাধ্যমে লুকানো থাকে। সঠিক পাসওয়ার্ড দিলে তবেই আসল অ্যাকাউন্ট সেট দেখা যায়, ফলে অনিচ্ছাকৃত এক্সপোজারের ঝুঁকি কমে।",
    "lukkey.system.hiddenAccounts.bullet1":
      "দৃশ্যমান ডিকয় অ্যাকাউন্টকে উচ্চ-মূল্যের লুকানো ওয়ালেট থেকে আলাদা রাখে",
    "lukkey.system.hiddenAccounts.bullet2":
      "দৈনন্দিন আনলক ফ্লোতে লুকানো ওয়ালেটগুলোকে দেখা যেতে দেয় না",
    "lukkey.system.hiddenAccounts.bullet3":
      "ভ্রমণ, পাবলিক স্পেস এবং জবরদস্তিমূলক পরিস্থিতির জন্য একটি ব্যবহারিক প্রাইভেসি স্তর যোগ করে",
  },
  mn: {
    "lukkey.highlights.eyebrow": "Гол онцлогууд",
    "lukkey.highlights.title": "Lukkey-ийн гол онцлогуудыг үзнэ үү.",
    "lukkey.highlights.description":
      "Эхлээд LUKKEY-ийн хамгийн чухал 5 давуу талыг хурдан ойлгоод, дараа нь хэсэг тус бүрийн дэлгэрэнгүйг үзээрэй.",
    "lukkey.highlights.cards.chip.title": "EAL6+ хамгаалалтын чип",
    "lukkey.highlights.cards.chip.description":
      "Тоног төхөөрөмжийн түвшний итгэлийн суурь нь баталгаажсан secure element доторх чухал криптограф өгөгдлийг хамгаална.",
    "lukkey.highlights.cards.chip.sectionLabel": "Чипийн аюулгүй байдал",
    "lukkey.highlights.cards.multiAccount.title":
      "3 бие даасан seed phrase",
    "lukkey.highlights.cards.multiAccount.description":
      "Урт хугацааны хөрөнгө, өдөр тутмын хөрөнгө болон өөр стратегиудыг нэг төхөөрөмж дээр тусгаарлан удирдаарай.",
    "lukkey.highlights.cards.multiAccount.sectionLabel": "Олон данс",
    "lukkey.highlights.cards.safeMode.title": "Аюулгүй горим",
    "lukkey.highlights.cards.safeMode.description":
      "Нуугдмал интерфэйс болон далд дансны урсгал нь аялал, олон нийтийн орчин, албадлагын үед ил гарах эрсдэлийг бууруулдаг.",
    "lukkey.highlights.cards.safeMode.sectionLabel": "Хамгаалалтын давхарга",
    "lukkey.highlights.cards.backup.title": "NFC нөөц карт",
    "lukkey.highlights.cards.backup.description":
      "Оффлайн тасралтгүй байдлыг хангах зориулалттай тусгай картаар recovery phrase-ээ нөөцлөх эсвэл сэргээхийн тулд товшино уу.",
    "lukkey.highlights.cards.backup.sectionLabel": "Нөөцлөлт",
    "lukkey.highlights.cards.trust.title":
      "Нээлттэй бөгөөд шалгаж болох аюулгүй байдал",
    "lukkey.highlights.cards.trust.description":
      "Cold wallet-д бие даасан шалгалт чухал. Нээлттэй архитектур нь итгэлийг зүгээр таамаглах биш, шалгаж болдог болгодог.",
    "lukkey.highlights.cards.trust.sectionLabel": "Итгэл",
    "lukkey.highlights.carousel.previous": "Өмнөх бүлэг",
    "lukkey.highlights.carousel.next": "Дараагийн бүлэг",
    "lukkey.design.featureTitle":
      "Өнгөт мэдрэгчтэй дэлгэц · Картын хэмжээтэй их бие",
    "lukkey.design.featureDescription":
      "Жинхэнэ банкны карттай 1:1 харьцуулахад ердөө 9.6 мм зузаан нь шууд анзаарагдана.",
    "lukkey.design.thickness": "Зузаан 9.6 мм",
    "lukkey.design.closing":
      "Макро шилжилт, урсах гэрлийн дараа ч эцсийн хэлбэр нь цэгцтэй, нарийн хийцтэй хэвээр үлдэнэ.",
    "lukkey.design.controls.closePanel": "Самбар хаах",
    "lukkey.design.feature.colors": "Өнгө",
    "lukkey.design.feature.sizes": "Хэмжээ",
    "lukkey.design.feature.display": "Дэлгэц",
    "lukkey.design.feature.connectivity": "Холболт",
    "lukkey.design.feature.durability": "Батерей",
    "lukkey.design.color.champagne": "Шампань",
    "lukkey.design.color.black": "Хар",
    "lukkey.design.color.silver": "Мөнгө",
    "lukkey.design.panel.colors.title": "Өнгө.",
    "lukkey.design.panel.colors.body":
      "Ялгарахуйц, амархан танигдах гурван төрлийн өнгөлгөөтэй.",
    "lukkey.design.panel.colors.selected":
      "Та одоо {{color}} өнгийн LUKKEY-г харж байна.",
    "lukkey.design.panel.sizes.body":
      "Хэмжээ: 93.2 мм (урт) x 56.7 мм (өргөн) x 9.6 мм (өндөр). Жин: 85 г. Кредит карттай ижил footprint, өдөр тутам авч явахад тохирсон нимгэн биетэй.",
    "lukkey.design.panel.display.body":
      "Дэлгэц: 4.3 инчийн мэдрэгчтэй дэлгэц, 480 x 800 нягтаршилтай бөгөөд баталгаажуулалт, гарын үсгийг тод харуулна.",
    "lukkey.design.panel.connectivity.body":
      "Холболт: Bluetooth дэмждэг тул аюулгүй утасгүй холболт болон жигд гүйлгээний урсгалыг хангана.",
    "lukkey.design.panel.durability.body":
      "Батерей: тасралтгүй ашиглавал 3 цаг хүртэл.",
    "lukkey.system.account.accountA": "Данс A",
    "lukkey.system.account.hiddenWallet": "Далд wallet",
    "lukkey.system.account.decoyVault": "Өгөөш wallet",
    "lukkey.system.account.locked": "Түгжээтэй",
    "lukkey.system.layers.primary": "Үндсэн",
    "lukkey.system.layers.vault": "Сан",
    "lukkey.system.layers.shadow": "Сүүдэр",
    "lukkey.system.modalImageAlt": "LUKKEY wallet бүтээгдэхүүний зураг",
    "lukkey.system.openDetailsAria": "{{title}}-ын дэлгэрэнгүйг нээх",
    "lukkey.system.safeModeAccess.titleStrong":
      "Аюулгүй горимын\nнэвтрэлт",
    "lukkey.system.safeModeAccess.titleSoft":
      "Тусгай нууц үг нь далдалсан хуудсыг нээж, бусад дансыг нууддаг.",
    "lukkey.system.safeModeAccess.modalTitle":
      "Аюулгүй горимын нэвтрэлт",
    "lukkey.system.safeModeAccess.modalDescription":
      "Аюулгүй горимын тусгай нууц үг нь тэмдэглэлийн апп мэт харагдах интерфэйсийг нээнэ. Зөвхөн зорилтот данс харагдаж, бусад wallet-ууд нуусан хэвээр байна.",
    "lukkey.system.safeModeAccess.bullet1":
      "Тайлагдсаны дараа та wallet-ийн бүрэн нүүр хуудас биш, өгөөш интерфэйс рүү орно",
    "lukkey.system.safeModeAccess.bullet2":
      "Эмзэг нөхцөлд одоогийнхоос бусад данснууд дэлгэц дээр харагдахгүй",
    "lukkey.system.safeModeAccess.bullet3":
      "Өдөр тутмын шалгалтын үеэр далд хөрөнгө ил гарах эрсдэлийг бууруулна",
    "lukkey.system.safeModeAccess.imageAlt":
      "Аюулгүй горимын нэвтрэлтийн зураглал",
    "lukkey.system.hiddenAccounts.titleStrong": "Далд\nдансууд",
    "lukkey.system.hiddenAccounts.titleSoft":
      "Өгөөш нэвтрэлт нь зөв нууц үг оруулах хүртэл эмзэг wallet-уудыг далд байлгана.",
    "lukkey.system.hiddenAccounts.modalTitle": "Далд дансууд",
    "lukkey.system.hiddenAccounts.modalDescription":
      "Эмзэг wallet-ууд өгөөш нэвтрэлтийн механизмаар нуугдана. Зөв нууц үг оруулсны дараа л жинхэнэ дансны багц харагдах тул санамсаргүй илрэх эрсдэл буурна.",
    "lukkey.system.hiddenAccounts.bullet1":
      "Харагдах өгөөш дансыг өндөр үнэ цэнтэй далд wallet-уудаас тусгаарлана",
    "lukkey.system.hiddenAccounts.bullet2":
      "Өдөр тутмын тайлах урсгалд далд wallet-ууд гарч ирэхээс сэргийлнэ",
    "lukkey.system.hiddenAccounts.bullet3":
      "Аялал, олон нийтийн газар, албадлагын нөхцөлд хэрэгтэй нууцлалын нэмэлт давхарга өгнө",
  },
};
